/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.0.0 (NJsonSchema v10.1.18.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const CONTENT_API_BASE_URL = new InjectionToken<string>('CONTENT_API_BASE_URL');

@Injectable()
export class ActivityApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ActivityDto | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/studio/content/activity/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ActivityDto | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/studio/content/activity/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryActivities(body: GetActivitiesInput | undefined): Observable<ActivityInfo[]> {
        let url_ = this.baseUrl + "/api/studio/content/activity/query-activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryActivities(<any>response_);
                } catch (e) {
                    return <Observable<ActivityInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processQueryActivities(response: HttpResponseBase): Observable<ActivityInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ActivityInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityInfo[]>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getActivityInfo(activityId: string | undefined): Observable<ActivityInfo> {
        let url_ = this.baseUrl + "/api/studio/content/activity/get-activity-info?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityInfo(<any>response_);
                } catch (e) {
                    return <Observable<ActivityInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityInfo(response: HttpResponseBase): Observable<ActivityInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reorderSegment(body: ReorderSegmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/activity/reorder-segment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderSegment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderSegment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReorderSegment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    publishChanges(activityId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/activity/publish-changes?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishChanges(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPublishChanges(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getActivityResults(activityId: string | undefined): Observable<StudentActivityResult[]> {
        let url_ = this.baseUrl + "/api/studio/content/activity/get-activity-results?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityResults(<any>response_);
                } catch (e) {
                    return <Observable<StudentActivityResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentActivityResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityResults(response: HttpResponseBase): Observable<StudentActivityResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StudentActivityResult.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentActivityResult[]>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getActivityPerformance(activityId: string | undefined): Observable<ActivityPerformanceDto> {
        let url_ = this.baseUrl + "/api/studio/content/activity/get-activity-performance?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityPerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityPerformance(<any>response_);
                } catch (e) {
                    return <Observable<ActivityPerformanceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityPerformanceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityPerformance(response: HttpResponseBase): Observable<ActivityPerformanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityPerformanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityPerformanceDto>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getActivityItemsResult(activityId: string | undefined): Observable<QuizItemResult[]> {
        let url_ = this.baseUrl + "/api/studio/content/activity/get-activity-items-result?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityItemsResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityItemsResult(<any>response_);
                } catch (e) {
                    return <Observable<QuizItemResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuizItemResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityItemsResult(response: HttpResponseBase): Observable<QuizItemResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(QuizItemResult.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuizItemResult[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/studio/content/activity/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @param segmentId (optional) 
     * @param subjectId (optional) 
     * @param activityType (optional) 
     * @param publishStatus (optional) 
     * @return Success
     */
    getAll(courseId: number | undefined, segmentId: number | null | undefined, subjectId: number | null | undefined, activityType: string | null | undefined, publishStatus: PublishStatusKind | undefined): Observable<PagedResultDtoOfActivityDto> {
        let url_ = this.baseUrl + "/api/studio/content/activity/get-all?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (segmentId !== undefined && segmentId !== null)
            url_ += "SegmentId=" + encodeURIComponent("" + segmentId) + "&";
        if (subjectId !== undefined && subjectId !== null)
            url_ += "SubjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (activityType !== undefined && activityType !== null)
            url_ += "ActivityType=" + encodeURIComponent("" + activityType) + "&";
        if (publishStatus === null)
            throw new Error("The parameter 'publishStatus' cannot be null.");
        else if (publishStatus !== undefined)
            url_ += "PublishStatus=" + encodeURIComponent("" + publishStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfActivityDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/activity/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AssignmentsApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAssignments(): Observable<CourseAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/assignments/get-assignments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignments(<any>response_);
                } catch (e) {
                    return <Observable<CourseAssignmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseAssignmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssignments(response: HttpResponseBase): Observable<CourseAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CourseAssignmentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseAssignmentDto[]>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getAssignment(activityId: string | undefined): Observable<CourseAssignmentDto> {
        let url_ = this.baseUrl + "/api/studio/content/assignments/get-assignment?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignment(<any>response_);
                } catch (e) {
                    return <Observable<CourseAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssignment(response: HttpResponseBase): Observable<CourseAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseAssignmentDto>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getCourseAssignments(courseId: number | undefined): Observable<CourseAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/assignments/get-course-assignments?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseAssignments(<any>response_);
                } catch (e) {
                    return <Observable<CourseAssignmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseAssignmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCourseAssignments(response: HttpResponseBase): Observable<CourseAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CourseAssignmentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseAssignmentDto[]>(<any>null);
    }

    /**
     * @param attemptId (optional) 
     * @return Success
     */
    getLearnerAssignment(attemptId: string | undefined): Observable<LearnerAssignmentDto> {
        let url_ = this.baseUrl + "/api/studio/content/assignments/get-learner-assignment?";
        if (attemptId === null)
            throw new Error("The parameter 'attemptId' cannot be null.");
        else if (attemptId !== undefined)
            url_ += "attemptId=" + encodeURIComponent("" + attemptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLearnerAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLearnerAssignment(<any>response_);
                } catch (e) {
                    return <Observable<LearnerAssignmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LearnerAssignmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLearnerAssignment(response: HttpResponseBase): Observable<LearnerAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LearnerAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LearnerAssignmentDto>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getAssignmentsForActivity(activityId: string | undefined): Observable<LearnerAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/assignments/get-assignments-for-activity?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignmentsForActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignmentsForActivity(<any>response_);
                } catch (e) {
                    return <Observable<LearnerAssignmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LearnerAssignmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssignmentsForActivity(response: HttpResponseBase): Observable<LearnerAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LearnerAssignmentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LearnerAssignmentDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAssignment(body: MarkAssignmentRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/assignments/mark-assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAssignment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    returnAssignment(body: ReturnAssignmentRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/assignments/return-assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnAssignment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReturnAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetAssignment(body: ResetAssignmentRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/assignments/reset-assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetAssignment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CourseApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCourses(): Observable<CourseDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/course/get-all-courses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCourses(<any>response_);
                } catch (e) {
                    return <Observable<CourseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCourses(response: HttpResponseBase): Observable<CourseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CourseDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMemberCourses(): Observable<CourseDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/course/get-member-courses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberCourses(<any>response_);
                } catch (e) {
                    return <Observable<CourseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberCourses(response: HttpResponseBase): Observable<CourseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CourseDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCourse(body: CreateCourseRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/studio/content/course/create-course";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCourse(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCourse(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCourse(body: UpdateCourseRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/course/update-course";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCourse(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCourse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getCourseDetail(courseId: number | undefined): Observable<CourseDetailsDto> {
        let url_ = this.baseUrl + "/api/studio/content/course/get-course-detail?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseDetail(<any>response_);
                } catch (e) {
                    return <Observable<CourseDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCourseDetail(response: HttpResponseBase): Observable<CourseDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseDetailsDto>(<any>null);
    }
}

@Injectable()
export class CourseClassApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<LiveClassDto> {
        let url_ = this.baseUrl + "/api/studio/content/course-class/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<LiveClassDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LiveClassDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LiveClassDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiveClassDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LiveClassDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: LiveClassDto | undefined): Observable<LiveClassDto> {
        let url_ = this.baseUrl + "/api/studio/content/course-class/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<LiveClassDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LiveClassDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LiveClassDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiveClassDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LiveClassDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: LiveClassDto | undefined): Observable<LiveClassDto> {
        let url_ = this.baseUrl + "/api/studio/content/course-class/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<LiveClassDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LiveClassDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LiveClassDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiveClassDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LiveClassDto>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getCourseMeetings(courseId: number | undefined): Observable<LiveClassDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/course-class/get-course-meetings?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseMeetings(<any>response_);
                } catch (e) {
                    return <Observable<LiveClassDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LiveClassDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCourseMeetings(response: HttpResponseBase): Observable<LiveClassDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LiveClassDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LiveClassDto[]>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfLiveClassDto> {
        let url_ = this.baseUrl + "/api/studio/content/course-class/get-all?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLiveClassDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLiveClassDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfLiveClassDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLiveClassDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLiveClassDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/course-class/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CourseSegmentApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getCourseSegments(courseId: number | undefined): Observable<CourseSegmentDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/course-segment/get-course-segments?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseSegments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseSegments(<any>response_);
                } catch (e) {
                    return <Observable<CourseSegmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseSegmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCourseSegments(response: HttpResponseBase): Observable<CourseSegmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CourseSegmentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseSegmentDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CourseSegmentDto> {
        let url_ = this.baseUrl + "/api/studio/content/course-segment/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CourseSegmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseSegmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CourseSegmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseSegmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseSegmentDto>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCourseSegmentDto> {
        let url_ = this.baseUrl + "/api/studio/content/course-segment/get-all?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCourseSegmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCourseSegmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCourseSegmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCourseSegmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCourseSegmentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CourseSegmentDto | undefined): Observable<CourseSegmentDto> {
        let url_ = this.baseUrl + "/api/studio/content/course-segment/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CourseSegmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseSegmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CourseSegmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseSegmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseSegmentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CourseSegmentDto | undefined): Observable<CourseSegmentDto> {
        let url_ = this.baseUrl + "/api/studio/content/course-segment/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CourseSegmentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CourseSegmentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CourseSegmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseSegmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseSegmentDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/course-segment/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ImageMediaServiceApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchImageAssets(body: SearchImageMediaRequest | undefined): Observable<SearchImageMediaResponse> {
        let url_ = this.baseUrl + "/api/studio/content/image-media-service/search-image-assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchImageAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchImageAssets(<any>response_);
                } catch (e) {
                    return <Observable<SearchImageMediaResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchImageMediaResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSearchImageAssets(response: HttpResponseBase): Observable<SearchImageMediaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchImageMediaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchImageMediaResponse>(<any>null);
    }
}

@Injectable()
export class LessonApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: LessonDto | undefined): Observable<LessonDto> {
        let url_ = this.baseUrl + "/api/studio/content/lesson/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<LessonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LessonDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LessonDto>(<any>null);
    }

    /**
     * @param lessonId (optional) 
     * @return Success
     */
    getLessonDetail(lessonId: string | undefined): Observable<LessonDetailDto> {
        let url_ = this.baseUrl + "/api/studio/content/lesson/get-lesson-detail?";
        if (lessonId === null)
            throw new Error("The parameter 'lessonId' cannot be null.");
        else if (lessonId !== undefined)
            url_ += "lessonId=" + encodeURIComponent("" + lessonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLessonDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLessonDetail(<any>response_);
                } catch (e) {
                    return <Observable<LessonDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LessonDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLessonDetail(response: HttpResponseBase): Observable<LessonDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LessonDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LessonDetailDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<LessonDto> {
        let url_ = this.baseUrl + "/api/studio/content/lesson/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<LessonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LessonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LessonDto>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getAll(courseId: number | undefined): Observable<PagedResultDtoOfLessonDto> {
        let url_ = this.baseUrl + "/api/studio/content/lesson/get-all?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLessonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLessonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfLessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLessonDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: LessonDto | undefined): Observable<LessonDto> {
        let url_ = this.baseUrl + "/api/studio/content/lesson/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<LessonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LessonDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LessonDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/lesson/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MediaApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getFolderHierarchy(): Observable<MediaFolderDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/media/get-folder-hierarchy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFolderHierarchy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolderHierarchy(<any>response_);
                } catch (e) {
                    return <Observable<MediaFolderDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MediaFolderDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFolderHierarchy(response: HttpResponseBase): Observable<MediaFolderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MediaFolderDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaFolderDto[]>(<any>null);
    }

    /**
     * @param folderId (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getFolderImages(folderId: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<ImageMediaDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/media/get-folder-images?";
        if (folderId !== undefined && folderId !== null)
            url_ += "FolderId=" + encodeURIComponent("" + folderId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFolderImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolderImages(<any>response_);
                } catch (e) {
                    return <Observable<ImageMediaDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImageMediaDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFolderImages(response: HttpResponseBase): Observable<ImageMediaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ImageMediaDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImageMediaDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchFolderImages(body: SearchFolderImagesRequest | undefined): Observable<ImageMediaDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/media/search-folder-images";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFolderImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFolderImages(<any>response_);
                } catch (e) {
                    return <Observable<ImageMediaDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImageMediaDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processSearchFolderImages(response: HttpResponseBase): Observable<ImageMediaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ImageMediaDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImageMediaDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMediaFolder(body: AddMediaFolderRequest | undefined): Observable<MediaFolderDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/media/add-media-folder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMediaFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMediaFolder(<any>response_);
                } catch (e) {
                    return <Observable<MediaFolderDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MediaFolderDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processAddMediaFolder(response: HttpResponseBase): Observable<MediaFolderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MediaFolderDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaFolderDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameMediaFolder(body: EditMediaFolderRequest | undefined): Observable<MediaFolderDto[]> {
        let url_ = this.baseUrl + "/api/studio/content/media/rename-media-folder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameMediaFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameMediaFolder(<any>response_);
                } catch (e) {
                    return <Observable<MediaFolderDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MediaFolderDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processRenameMediaFolder(response: HttpResponseBase): Observable<MediaFolderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MediaFolderDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaFolderDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeMediaFolder(id: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/studio/content/media/remove-media-folder?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveMediaFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveMediaFolder(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveMediaFolder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class PresentationActivityApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getPresentation(activityId: string | undefined): Observable<PresentationActivityDto> {
        let url_ = this.baseUrl + "/api/studio/content/presentation-activity/get-presentation?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPresentation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPresentation(<any>response_);
                } catch (e) {
                    return <Observable<PresentationActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PresentationActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPresentation(response: HttpResponseBase): Observable<PresentationActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PresentationActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PresentationActivityDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PresentationActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/presentation-activity/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class QuizActivityApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getQuiz(activityId: string | undefined): Observable<QuizActivityDto> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-activity/get-quiz?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuiz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuiz(<any>response_);
                } catch (e) {
                    return <Observable<QuizActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuizActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuiz(response: HttpResponseBase): Observable<QuizActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuizActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuizActivityDto>(<any>null);
    }

    /**
     * @param quizId (optional) 
     * @param index (optional) 
     * @return Success
     */
    addPage(quizId: string | undefined, index: number | undefined): Observable<QuizEditPageDto> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-activity/add-page?";
        if (quizId === null)
            throw new Error("The parameter 'quizId' cannot be null.");
        else if (quizId !== undefined)
            url_ += "quizId=" + encodeURIComponent("" + quizId) + "&";
        if (index === null)
            throw new Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPage(<any>response_);
                } catch (e) {
                    return <Observable<QuizEditPageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuizEditPageDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddPage(response: HttpResponseBase): Observable<QuizEditPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuizEditPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuizEditPageDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: QuizDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-activity/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    remarkQuiz(body: RemarkQuizRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-activity/remark-quiz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemarkQuiz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemarkQuiz(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemarkQuiz(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markQuizAttempts(body: MarkQuizAttempts | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-activity/mark-quiz-attempts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkQuizAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkQuizAttempts(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkQuizAttempts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param quizId (optional) 
     * @return Success
     */
    returnQuiz(quizId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-activity/return-quiz?";
        if (quizId === null)
            throw new Error("The parameter 'quizId' cannot be null.");
        else if (quizId !== undefined)
            url_ += "quizId=" + encodeURIComponent("" + quizId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnQuiz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnQuiz(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReturnQuiz(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param segmentId (optional) 
     * @return Success
     */
    returnSegment(segmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-activity/return-segment?";
        if (segmentId === null)
            throw new Error("The parameter 'segmentId' cannot be null.");
        else if (segmentId !== undefined)
            url_ += "segmentId=" + encodeURIComponent("" + segmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnSegment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnSegment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReturnSegment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    returnAttempt(body: ReturnQuizAttemptInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-activity/return-attempt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnAttempt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnAttempt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReturnAttempt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyQuiz(body: CopyQuizInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-activity/copy-quiz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyQuiz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyQuiz(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCopyQuiz(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class QuizAssignmentApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param attemptId (optional) 
     * @return Success
     */
    getQuizAttempt(attemptId: string | undefined): Observable<GetQuizAssignmentResponse> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-assignment/get-quiz-attempt?";
        if (attemptId === null)
            throw new Error("The parameter 'attemptId' cannot be null.");
        else if (attemptId !== undefined)
            url_ += "AttemptId=" + encodeURIComponent("" + attemptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuizAttempt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuizAttempt(<any>response_);
                } catch (e) {
                    return <Observable<GetQuizAssignmentResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetQuizAssignmentResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuizAttempt(response: HttpResponseBase): Observable<GetQuizAssignmentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQuizAssignmentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQuizAssignmentResponse>(<any>null);
    }
}

@Injectable()
export class QuizDesignerApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQuizItem(body: UpdateQuizItemInput | undefined): Observable<QuizItemEditDto> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-designer/update-quiz-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuizItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuizItem(<any>response_);
                } catch (e) {
                    return <Observable<QuizItemEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuizItemEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateQuizItem(response: HttpResponseBase): Observable<QuizItemEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuizItemEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuizItemEditDto>(<any>null);
    }

    /**
     * @param pageId (optional) 
     * @return Success
     */
    getPageContent(pageId: string | undefined): Observable<QuizEditDto> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-designer/get-page-content?";
        if (pageId === null)
            throw new Error("The parameter 'pageId' cannot be null.");
        else if (pageId !== undefined)
            url_ += "pageId=" + encodeURIComponent("" + pageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPageContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPageContent(<any>response_);
                } catch (e) {
                    return <Observable<QuizEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuizEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPageContent(response: HttpResponseBase): Observable<QuizEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuizEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuizEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBlockTypes(): Observable<BlockType[]> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-designer/get-block-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlockTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlockTypes(<any>response_);
                } catch (e) {
                    return <Observable<BlockType[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BlockType[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBlockTypes(response: HttpResponseBase): Observable<BlockType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BlockType.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BlockType[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createQuizItem(body: CreateQuizItemInput | undefined): Observable<QuizItemEditDto> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-designer/create-quiz-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQuizItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQuizItem(<any>response_);
                } catch (e) {
                    return <Observable<QuizItemEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuizItemEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateQuizItem(response: HttpResponseBase): Observable<QuizItemEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuizItemEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuizItemEditDto>(<any>null);
    }

    /**
     * @param itemId (optional) 
     * @return Success
     */
    removeQuizItem(itemId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-designer/remove-quiz-item?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveQuizItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveQuizItem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveQuizItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    numberItems(body: NumberItemsInput | undefined): Observable<QuizItemPosition[]> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-designer/number-items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNumberItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNumberItems(<any>response_);
                } catch (e) {
                    return <Observable<QuizItemPosition[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuizItemPosition[]>><any>_observableThrow(response_);
        }));
    }

    protected processNumberItems(response: HttpResponseBase): Observable<QuizItemPosition[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(QuizItemPosition.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuizItemPosition[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPage(body: AddPageRequest | undefined): Observable<QuizEditPageDto> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-designer/add-page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPage(<any>response_);
                } catch (e) {
                    return <Observable<QuizEditPageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuizEditPageDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddPage(response: HttpResponseBase): Observable<QuizEditPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuizEditPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuizEditPageDto>(<any>null);
    }

    /**
     * @param pageId (optional) 
     * @param pages (optional) 
     * @param id (optional) 
     * @return Success
     */
    removePage(pageId: string | undefined, pages: QuizEditPageDto[] | null | undefined, id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/quiz-designer/remove-page?";
        if (pageId === null)
            throw new Error("The parameter 'pageId' cannot be null.");
        else if (pageId !== undefined)
            url_ += "PageId=" + encodeURIComponent("" + pageId) + "&";
        if (pages !== undefined && pages !== null)
            pages && pages.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Pages[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemovePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RecordingActivityApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    get(activityId: string | undefined): Observable<RecordingActivityDto> {
        let url_ = this.baseUrl + "/api/studio/content/recording-activity/get?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RecordingActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordingActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RecordingActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordingActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecordingActivityDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RecordingActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/recording-activity/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class StudentActivityApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryStudentActivity(body: GetStudentActivityInput | undefined): Observable<StudentActivityInfo[]> {
        let url_ = this.baseUrl + "/api/studio/content/student-activity/query-student-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryStudentActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryStudentActivity(<any>response_);
                } catch (e) {
                    return <Observable<StudentActivityInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentActivityInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processQueryStudentActivity(response: HttpResponseBase): Observable<StudentActivityInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StudentActivityInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentActivityInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetActivity(body: ResetStudentActivityInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/student-activity/reset-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetActivity(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    restartActivity(body: RestartStudentQuizInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/student-activity/restart-activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartActivity(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRestartActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class StudentsApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queryStudents(body: GetStudentsInput | undefined): Observable<StudentInfo[]> {
        let url_ = this.baseUrl + "/api/studio/content/students/query-students";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryStudents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryStudents(<any>response_);
                } catch (e) {
                    return <Observable<StudentInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processQueryStudents(response: HttpResponseBase): Observable<StudentInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StudentInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentInfo[]>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @param studentId (optional) 
     * @return Success
     */
    getCourseStudent(courseId: number | undefined, studentId: number | undefined): Observable<StudentInfo> {
        let url_ = this.baseUrl + "/api/studio/content/students/get-course-student?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseStudent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseStudent(<any>response_);
                } catch (e) {
                    return <Observable<StudentInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetCourseStudent(response: HttpResponseBase): Observable<StudentInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentInfo>(<any>null);
    }
}

@Injectable()
export class SubjectApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SubjectDto> {
        let url_ = this.baseUrl + "/api/studio/content/subject/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<SubjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SubjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubjectDto>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getAll(courseId: number | undefined): Observable<PagedResultDtoOfSubjectDto> {
        let url_ = this.baseUrl + "/api/studio/content/subject/get-all?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSubjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSubjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfSubjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSubjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSubjectDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: SubjectDto | undefined): Observable<SubjectDto> {
        let url_ = this.baseUrl + "/api/studio/content/subject/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<SubjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SubjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubjectDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: SubjectDto | undefined): Observable<SubjectDto> {
        let url_ = this.baseUrl + "/api/studio/content/subject/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<SubjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SubjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubjectDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/subject/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TopicApiProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONTENT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TopicModel | undefined): Observable<TopicModel> {
        let url_ = this.baseUrl + "/api/studio/content/topic/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TopicModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TopicModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TopicModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopicModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopicModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TopicModel | undefined): Observable<TopicModel> {
        let url_ = this.baseUrl + "/api/studio/content/topic/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TopicModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TopicModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TopicModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopicModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopicModel>(<any>null);
    }

    /**
     * @param subjectId (optional) 
     * @return Success
     */
    getTopics(subjectId: number | undefined): Observable<TopicModel[]> {
        let url_ = this.baseUrl + "/api/studio/content/topic/get-topics?";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopics(<any>response_);
                } catch (e) {
                    return <Observable<TopicModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TopicModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopics(response: HttpResponseBase): Observable<TopicModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TopicModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopicModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reorderTopics(body: ReorderItemsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/topic/reorder-topics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderTopics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderTopics(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReorderTopics(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TopicModel> {
        let url_ = this.baseUrl + "/api/studio/content/topic/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TopicModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TopicModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TopicModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopicModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopicModel>(<any>null);
    }

    /**
     * @param subjectId (optional) 
     * @return Success
     */
    getAll(subjectId: number | undefined): Observable<PagedResultDtoOfTopicModel> {
        let url_ = this.baseUrl + "/api/studio/content/topic/get-all?";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "SubjectId=" + encodeURIComponent("" + subjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTopicModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTopicModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTopicModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTopicModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTopicModel>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/studio/content/topic/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class MediaFieldBaseOfImageField implements IMediaFieldBaseOfImageField {
    id: number;
    url: string | undefined;
    readonly hasValue: boolean;

    protected _discriminator: string;

    constructor(data?: IMediaFieldBaseOfImageField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "MediaFieldBaseOfImageField";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            (<any>this).hasValue = _data["hasValue"];
        }
    }

    static fromJS(data: any): MediaFieldBaseOfImageField {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ImageField") {
            let result = new ImageField();
            result.init(data);
            return result;
        }
        let result = new MediaFieldBaseOfImageField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["id"] = this.id;
        data["url"] = this.url;
        data["hasValue"] = this.hasValue;
        return data; 
    }

    clone(): MediaFieldBaseOfImageField {
        const json = this.toJSON();
        let result = new MediaFieldBaseOfImageField();
        result.init(json);
        return result;
    }
}

export interface IMediaFieldBaseOfImageField {
    id: number;
    url: string | undefined;
    hasValue: boolean;
}

export class ImageField extends MediaFieldBaseOfImageField implements IImageField {

    constructor(data?: IImageField) {
        super(data);
        this._discriminator = "ImageField";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ImageField {
        data = typeof data === 'object' ? data : {};
        let result = new ImageField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): ImageField {
        const json = this.toJSON();
        let result = new ImageField();
        result.init(json);
        return result;
    }
}

export interface IImageField extends IMediaFieldBaseOfImageField {
}

export enum PublishStatusKind {
    New = <any>"New",
    Draft = <any>"Draft",
    Review = <any>"Review",
    Published = <any>"Published",
    Archived = <any>"Archived",
}

export class ActivityDto implements IActivityDto {
    courseId: number;
    course: string | undefined;
    lessonId: string | undefined;
    activityType: string | undefined;
    title: string | undefined;
    description: string | undefined;
    previewImage: ImageField;
    publishingStatus: PublishStatusKind;
    includeInPreview: boolean;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    tenantId: number;
    assignmentType: string | undefined;
    assignmentTypeId: number;
    subjectId: number;
    subject: string | undefined;
    accessLevels: number[] | undefined;
    segmentId: number | undefined;
    segment: string | undefined;
    topicId: number | undefined;
    topic: string | undefined;
    id: string;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.course = _data["course"];
            this.lessonId = _data["lessonId"];
            this.activityType = _data["activityType"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.previewImage = _data["previewImage"] ? ImageField.fromJS(_data["previewImage"]) : <any>undefined;
            this.publishingStatus = _data["publishingStatus"];
            this.includeInPreview = _data["includeInPreview"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.assignmentType = _data["assignmentType"];
            this.assignmentTypeId = _data["assignmentTypeId"];
            this.subjectId = _data["subjectId"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["accessLevels"])) {
                this.accessLevels = [] as any;
                for (let item of _data["accessLevels"])
                    this.accessLevels.push(item);
            }
            this.segmentId = _data["segmentId"];
            this.segment = _data["segment"];
            this.topicId = _data["topicId"];
            this.topic = _data["topic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["course"] = this.course;
        data["lessonId"] = this.lessonId;
        data["activityType"] = this.activityType;
        data["title"] = this.title;
        data["description"] = this.description;
        data["previewImage"] = this.previewImage ? this.previewImage.toJSON() : <any>undefined;
        data["publishingStatus"] = this.publishingStatus;
        data["includeInPreview"] = this.includeInPreview;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["assignmentType"] = this.assignmentType;
        data["assignmentTypeId"] = this.assignmentTypeId;
        data["subjectId"] = this.subjectId;
        data["subject"] = this.subject;
        if (Array.isArray(this.accessLevels)) {
            data["accessLevels"] = [];
            for (let item of this.accessLevels)
                data["accessLevels"].push(item);
        }
        data["segmentId"] = this.segmentId;
        data["segment"] = this.segment;
        data["topicId"] = this.topicId;
        data["topic"] = this.topic;
        data["id"] = this.id;
        return data; 
    }

    clone(): ActivityDto {
        const json = this.toJSON();
        let result = new ActivityDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDto {
    courseId: number;
    course: string | undefined;
    lessonId: string | undefined;
    activityType: string | undefined;
    title: string | undefined;
    description: string | undefined;
    previewImage: ImageField;
    publishingStatus: PublishStatusKind;
    includeInPreview: boolean;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    tenantId: number;
    assignmentType: string | undefined;
    assignmentTypeId: number;
    subjectId: number;
    subject: string | undefined;
    accessLevels: number[] | undefined;
    segmentId: number | undefined;
    segment: string | undefined;
    topicId: number | undefined;
    topic: string | undefined;
    id: string;
}

export class GetActivitiesInput implements IGetActivitiesInput {
    courseId: number;
    segmentId: number | undefined;
    subjectId: number | undefined;
    activityType: string | undefined;
    publishStatus: PublishStatusKind;

    constructor(data?: IGetActivitiesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.segmentId = _data["segmentId"];
            this.subjectId = _data["subjectId"];
            this.activityType = _data["activityType"];
            this.publishStatus = _data["publishStatus"];
        }
    }

    static fromJS(data: any): GetActivitiesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivitiesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["segmentId"] = this.segmentId;
        data["subjectId"] = this.subjectId;
        data["activityType"] = this.activityType;
        data["publishStatus"] = this.publishStatus;
        return data; 
    }

    clone(): GetActivitiesInput {
        const json = this.toJSON();
        let result = new GetActivitiesInput();
        result.init(json);
        return result;
    }
}

export interface IGetActivitiesInput {
    courseId: number;
    segmentId: number | undefined;
    subjectId: number | undefined;
    activityType: string | undefined;
    publishStatus: PublishStatusKind;
}

export class ActivityPageDto implements IActivityPageDto {
    id: string;
    activityId: string;
    title: string | undefined;
    itemIndex: number;

    constructor(data?: IActivityPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityId = _data["activityId"];
            this.title = _data["title"];
            this.itemIndex = _data["itemIndex"];
        }
    }

    static fromJS(data: any): ActivityPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["title"] = this.title;
        data["itemIndex"] = this.itemIndex;
        return data; 
    }

    clone(): ActivityPageDto {
        const json = this.toJSON();
        let result = new ActivityPageDto();
        result.init(json);
        return result;
    }
}

export interface IActivityPageDto {
    id: string;
    activityId: string;
    title: string | undefined;
    itemIndex: number;
}

export class ActivityInfo implements IActivityInfo {
    id: string;
    courseId: number;
    course: string | undefined;
    activityType: string | undefined;
    title: string | undefined;
    publishingStatus: PublishStatusKind;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    assignmentType: string | undefined;
    assignmentTypeId: number;
    subjectId: number;
    subject: string | undefined;
    segmentId: number | undefined;
    segment: string | undefined;
    sequenceNumber: number;
    topicId: number | undefined;
    topic: string | undefined;
    readonly hasPages: boolean;
    pages: ActivityPageDto[] | undefined;

    constructor(data?: IActivityInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courseId = _data["courseId"];
            this.course = _data["course"];
            this.activityType = _data["activityType"];
            this.title = _data["title"];
            this.publishingStatus = _data["publishingStatus"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.assignmentType = _data["assignmentType"];
            this.assignmentTypeId = _data["assignmentTypeId"];
            this.subjectId = _data["subjectId"];
            this.subject = _data["subject"];
            this.segmentId = _data["segmentId"];
            this.segment = _data["segment"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.topicId = _data["topicId"];
            this.topic = _data["topic"];
            (<any>this).hasPages = _data["hasPages"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages.push(ActivityPageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courseId"] = this.courseId;
        data["course"] = this.course;
        data["activityType"] = this.activityType;
        data["title"] = this.title;
        data["publishingStatus"] = this.publishingStatus;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["assignmentType"] = this.assignmentType;
        data["assignmentTypeId"] = this.assignmentTypeId;
        data["subjectId"] = this.subjectId;
        data["subject"] = this.subject;
        data["segmentId"] = this.segmentId;
        data["segment"] = this.segment;
        data["sequenceNumber"] = this.sequenceNumber;
        data["topicId"] = this.topicId;
        data["topic"] = this.topic;
        data["hasPages"] = this.hasPages;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ActivityInfo {
        const json = this.toJSON();
        let result = new ActivityInfo();
        result.init(json);
        return result;
    }
}

export interface IActivityInfo {
    id: string;
    courseId: number;
    course: string | undefined;
    activityType: string | undefined;
    title: string | undefined;
    publishingStatus: PublishStatusKind;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    assignmentType: string | undefined;
    assignmentTypeId: number;
    subjectId: number;
    subject: string | undefined;
    segmentId: number | undefined;
    segment: string | undefined;
    sequenceNumber: number;
    topicId: number | undefined;
    topic: string | undefined;
    hasPages: boolean;
    pages: ActivityPageDto[] | undefined;
}

export class ActivitySequence implements IActivitySequence {
    activityId: string;
    sequenceNumber: number;

    constructor(data?: IActivitySequence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.sequenceNumber = _data["sequenceNumber"];
        }
    }

    static fromJS(data: any): ActivitySequence {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySequence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["sequenceNumber"] = this.sequenceNumber;
        return data; 
    }

    clone(): ActivitySequence {
        const json = this.toJSON();
        let result = new ActivitySequence();
        result.init(json);
        return result;
    }
}

export interface IActivitySequence {
    activityId: string;
    sequenceNumber: number;
}

export class ReorderSegmentInput implements IReorderSegmentInput {
    sequence: ActivitySequence[] | undefined;

    constructor(data?: IReorderSegmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sequence"])) {
                this.sequence = [] as any;
                for (let item of _data["sequence"])
                    this.sequence.push(ActivitySequence.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReorderSegmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderSegmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sequence)) {
            data["sequence"] = [];
            for (let item of this.sequence)
                data["sequence"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ReorderSegmentInput {
        const json = this.toJSON();
        let result = new ReorderSegmentInput();
        result.init(json);
        return result;
    }
}

export interface IReorderSegmentInput {
    sequence: ActivitySequence[] | undefined;
}

export enum ActivityStatusKind {
    Upcoming = <any>"Upcoming",
    Due = <any>"Due",
    InProgress = <any>"InProgress",
    Completed = <any>"Completed",
    Closed = <any>"Closed",
    Submitted = <any>"Submitted",
}

export class StudentActivityResult implements IStudentActivityResult {
    subjectId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    readonly studentName: string | undefined;
    subject: string | undefined;
    title: string | undefined;
    assignmentTypeId: number;
    assignmentType: string | undefined;
    activityType: string | undefined;
    activityStatus: ActivityStatusKind;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    completedTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    score: number;
    lastAttemptId: string | undefined;
    readonly durationMins: number | undefined;
    readonly isCompleted: boolean;

    constructor(data?: IStudentActivityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            (<any>this).studentName = _data["studentName"];
            this.subject = _data["subject"];
            this.title = _data["title"];
            this.assignmentTypeId = _data["assignmentTypeId"];
            this.assignmentType = _data["assignmentType"];
            this.activityType = _data["activityType"];
            this.activityStatus = _data["activityStatus"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.completedTime = _data["completedTime"] ? moment(_data["completedTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.score = _data["score"];
            this.lastAttemptId = _data["lastAttemptId"];
            (<any>this).durationMins = _data["durationMins"];
            (<any>this).isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): StudentActivityResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudentActivityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["studentName"] = this.studentName;
        data["subject"] = this.subject;
        data["title"] = this.title;
        data["assignmentTypeId"] = this.assignmentTypeId;
        data["assignmentType"] = this.assignmentType;
        data["activityType"] = this.activityType;
        data["activityStatus"] = this.activityStatus;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["completedTime"] = this.completedTime ? this.completedTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["score"] = this.score;
        data["lastAttemptId"] = this.lastAttemptId;
        data["durationMins"] = this.durationMins;
        data["isCompleted"] = this.isCompleted;
        return data; 
    }

    clone(): StudentActivityResult {
        const json = this.toJSON();
        let result = new StudentActivityResult();
        result.init(json);
        return result;
    }
}

export interface IStudentActivityResult {
    subjectId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    studentName: string | undefined;
    subject: string | undefined;
    title: string | undefined;
    assignmentTypeId: number;
    assignmentType: string | undefined;
    activityType: string | undefined;
    activityStatus: ActivityStatusKind;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    completedTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    score: number;
    lastAttemptId: string | undefined;
    durationMins: number | undefined;
    isCompleted: boolean;
}

export class ActivityPerformanceDto implements IActivityPerformanceDto {
    activityId: string;
    assigned: number;
    completed: number;
    averageScore: number;
    maxScore: number;
    minScore: number;
    gradeA: number;
    gradeB: number;
    gradeC: number;
    gradeD: number;
    gradeF: number;

    constructor(data?: IActivityPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.assigned = _data["assigned"];
            this.completed = _data["completed"];
            this.averageScore = _data["averageScore"];
            this.maxScore = _data["maxScore"];
            this.minScore = _data["minScore"];
            this.gradeA = _data["gradeA"];
            this.gradeB = _data["gradeB"];
            this.gradeC = _data["gradeC"];
            this.gradeD = _data["gradeD"];
            this.gradeF = _data["gradeF"];
        }
    }

    static fromJS(data: any): ActivityPerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["assigned"] = this.assigned;
        data["completed"] = this.completed;
        data["averageScore"] = this.averageScore;
        data["maxScore"] = this.maxScore;
        data["minScore"] = this.minScore;
        data["gradeA"] = this.gradeA;
        data["gradeB"] = this.gradeB;
        data["gradeC"] = this.gradeC;
        data["gradeD"] = this.gradeD;
        data["gradeF"] = this.gradeF;
        return data; 
    }

    clone(): ActivityPerformanceDto {
        const json = this.toJSON();
        let result = new ActivityPerformanceDto();
        result.init(json);
        return result;
    }
}

export interface IActivityPerformanceDto {
    activityId: string;
    assigned: number;
    completed: number;
    averageScore: number;
    maxScore: number;
    minScore: number;
    gradeA: number;
    gradeB: number;
    gradeC: number;
    gradeD: number;
    gradeF: number;
}

export class QuizItemResult implements IQuizItemResult {
    activityId: string;
    title: string | undefined;
    itemNumber: number;
    correct: number;
    incorrect: number;
    noResponse: number;

    constructor(data?: IQuizItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.title = _data["title"];
            this.itemNumber = _data["itemNumber"];
            this.correct = _data["correct"];
            this.incorrect = _data["incorrect"];
            this.noResponse = _data["noResponse"];
        }
    }

    static fromJS(data: any): QuizItemResult {
        data = typeof data === 'object' ? data : {};
        let result = new QuizItemResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["title"] = this.title;
        data["itemNumber"] = this.itemNumber;
        data["correct"] = this.correct;
        data["incorrect"] = this.incorrect;
        data["noResponse"] = this.noResponse;
        return data; 
    }

    clone(): QuizItemResult {
        const json = this.toJSON();
        let result = new QuizItemResult();
        result.init(json);
        return result;
    }
}

export interface IQuizItemResult {
    activityId: string;
    title: string | undefined;
    itemNumber: number;
    correct: number;
    incorrect: number;
    noResponse: number;
}

export class PagedResultDtoOfActivityDto implements IPagedResultDtoOfActivityDto {
    totalCount: number;
    items: ActivityDto[] | undefined;

    constructor(data?: IPagedResultDtoOfActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfActivityDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfActivityDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfActivityDto {
    totalCount: number;
    items: ActivityDto[] | undefined;
}

export enum MarkerModeKind {
    Automatic = <any>"Automatic",
    Manual = <any>"Manual",
}

export class CourseAssignmentDto implements ICourseAssignmentDto {
    courseId: number;
    course: string | undefined;
    subjectId: number;
    assignmentTypeId: number;
    assignmentType: string | undefined;
    subject: string | undefined;
    title: string | undefined;
    releaseDate: moment.Moment | undefined;
    markerMode: MarkerModeKind;
    publishingStatus: PublishStatusKind;
    totalSubmitted: number;
    totalReturned: number;
    totalMarked: number;
    id: string;

    constructor(data?: ICourseAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.course = _data["course"];
            this.subjectId = _data["subjectId"];
            this.assignmentTypeId = _data["assignmentTypeId"];
            this.assignmentType = _data["assignmentType"];
            this.subject = _data["subject"];
            this.title = _data["title"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            this.markerMode = _data["markerMode"];
            this.publishingStatus = _data["publishingStatus"];
            this.totalSubmitted = _data["totalSubmitted"];
            this.totalReturned = _data["totalReturned"];
            this.totalMarked = _data["totalMarked"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["course"] = this.course;
        data["subjectId"] = this.subjectId;
        data["assignmentTypeId"] = this.assignmentTypeId;
        data["assignmentType"] = this.assignmentType;
        data["subject"] = this.subject;
        data["title"] = this.title;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["markerMode"] = this.markerMode;
        data["publishingStatus"] = this.publishingStatus;
        data["totalSubmitted"] = this.totalSubmitted;
        data["totalReturned"] = this.totalReturned;
        data["totalMarked"] = this.totalMarked;
        data["id"] = this.id;
        return data; 
    }

    clone(): CourseAssignmentDto {
        const json = this.toJSON();
        let result = new CourseAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface ICourseAssignmentDto {
    courseId: number;
    course: string | undefined;
    subjectId: number;
    assignmentTypeId: number;
    assignmentType: string | undefined;
    subject: string | undefined;
    title: string | undefined;
    releaseDate: moment.Moment | undefined;
    markerMode: MarkerModeKind;
    publishingStatus: PublishStatusKind;
    totalSubmitted: number;
    totalReturned: number;
    totalMarked: number;
    id: string;
}

export enum AttemptStatusKind {
    InProgress = <any>"InProgress",
    Submitted = <any>"Submitted",
    Marked = <any>"Marked",
    Completed = <any>"Completed",
}

export class LearnerAssignmentDto implements ILearnerAssignmentDto {
    attemptId: string;
    activityId: string;
    startTime: moment.Moment | undefined;
    completeTime: moment.Moment | undefined;
    studentId: number;
    title: string | undefined;
    subject: string | undefined;
    assignmentType: string | undefined;
    status: AttemptStatusKind;
    isCompleted: boolean;
    studentName: string | undefined;
    gradePercentage: number;
    marksEarned: number;
    marksTotal: number;

    constructor(data?: ILearnerAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
            this.activityId = _data["activityId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.completeTime = _data["completeTime"] ? moment(_data["completeTime"].toString()) : <any>undefined;
            this.studentId = _data["studentId"];
            this.title = _data["title"];
            this.subject = _data["subject"];
            this.assignmentType = _data["assignmentType"];
            this.status = _data["status"];
            this.isCompleted = _data["isCompleted"];
            this.studentName = _data["studentName"];
            this.gradePercentage = _data["gradePercentage"];
            this.marksEarned = _data["marksEarned"];
            this.marksTotal = _data["marksTotal"];
        }
    }

    static fromJS(data: any): LearnerAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LearnerAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        data["activityId"] = this.activityId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["completeTime"] = this.completeTime ? this.completeTime.toISOString() : <any>undefined;
        data["studentId"] = this.studentId;
        data["title"] = this.title;
        data["subject"] = this.subject;
        data["assignmentType"] = this.assignmentType;
        data["status"] = this.status;
        data["isCompleted"] = this.isCompleted;
        data["studentName"] = this.studentName;
        data["gradePercentage"] = this.gradePercentage;
        data["marksEarned"] = this.marksEarned;
        data["marksTotal"] = this.marksTotal;
        return data; 
    }

    clone(): LearnerAssignmentDto {
        const json = this.toJSON();
        let result = new LearnerAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface ILearnerAssignmentDto {
    attemptId: string;
    activityId: string;
    startTime: moment.Moment | undefined;
    completeTime: moment.Moment | undefined;
    studentId: number;
    title: string | undefined;
    subject: string | undefined;
    assignmentType: string | undefined;
    status: AttemptStatusKind;
    isCompleted: boolean;
    studentName: string | undefined;
    gradePercentage: number;
    marksEarned: number;
    marksTotal: number;
}

export enum MarkResultKind {
    NotMarked = <any>"NotMarked",
    InCorrect = <any>"InCorrect",
    PartiallyCorrect = <any>"PartiallyCorrect",
    Correct = <any>"Correct",
    NoResponse = <any>"NoResponse",
    MarkerNotFound = <any>"MarkerNotFound",
}

export class ResponseMarkDto implements IResponseMarkDto {
    responseItemId: string;
    points: number;
    totalPoints: number;
    comments: string | undefined;
    markResult: MarkResultKind;

    constructor(data?: IResponseMarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseItemId = _data["responseItemId"];
            this.points = _data["points"];
            this.totalPoints = _data["totalPoints"];
            this.comments = _data["comments"];
            this.markResult = _data["markResult"];
        }
    }

    static fromJS(data: any): ResponseMarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseMarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseItemId"] = this.responseItemId;
        data["points"] = this.points;
        data["totalPoints"] = this.totalPoints;
        data["comments"] = this.comments;
        data["markResult"] = this.markResult;
        return data; 
    }

    clone(): ResponseMarkDto {
        const json = this.toJSON();
        let result = new ResponseMarkDto();
        result.init(json);
        return result;
    }
}

export interface IResponseMarkDto {
    responseItemId: string;
    points: number;
    totalPoints: number;
    comments: string | undefined;
    markResult: MarkResultKind;
}

export class MarkAssignmentRequest implements IMarkAssignmentRequest {
    attemptId: string;
    marks: ResponseMarkDto[] | undefined;

    constructor(data?: IMarkAssignmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
            if (Array.isArray(_data["marks"])) {
                this.marks = [] as any;
                for (let item of _data["marks"])
                    this.marks.push(ResponseMarkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkAssignmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAssignmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        if (Array.isArray(this.marks)) {
            data["marks"] = [];
            for (let item of this.marks)
                data["marks"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MarkAssignmentRequest {
        const json = this.toJSON();
        let result = new MarkAssignmentRequest();
        result.init(json);
        return result;
    }
}

export interface IMarkAssignmentRequest {
    attemptId: string;
    marks: ResponseMarkDto[] | undefined;
}

export class ReturnAssignmentRequest implements IReturnAssignmentRequest {
    attemptId: string;

    constructor(data?: IReturnAssignmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
        }
    }

    static fromJS(data: any): ReturnAssignmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnAssignmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        return data; 
    }

    clone(): ReturnAssignmentRequest {
        const json = this.toJSON();
        let result = new ReturnAssignmentRequest();
        result.init(json);
        return result;
    }
}

export interface IReturnAssignmentRequest {
    attemptId: string;
}

export class ResetAssignmentRequest implements IResetAssignmentRequest {
    attemptId: string;

    constructor(data?: IResetAssignmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
        }
    }

    static fromJS(data: any): ResetAssignmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetAssignmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        return data; 
    }

    clone(): ResetAssignmentRequest {
        const json = this.toJSON();
        let result = new ResetAssignmentRequest();
        result.init(json);
        return result;
    }
}

export interface IResetAssignmentRequest {
    attemptId: string;
}

export enum EducationLevelKind {
    Primary = <any>"Primary",
    Secondary = <any>"Secondary",
    Tertiary = <any>"Tertiary",
}

export class CourseDto implements ICourseDto {
    name: string | undefined;
    description: string | undefined;
    gradeLevelId: string | undefined;
    gradeLevel: string | undefined;
    isActive: boolean;
    educationLevel: EducationLevelKind;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    schoolYear: string | undefined;
    id: number;

    constructor(data?: ICourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.gradeLevelId = _data["gradeLevelId"];
            this.gradeLevel = _data["gradeLevel"];
            this.isActive = _data["isActive"];
            this.educationLevel = _data["educationLevel"];
            this.availableFrom = _data["availableFrom"] ? moment(_data["availableFrom"].toString()) : <any>undefined;
            this.availableTo = _data["availableTo"] ? moment(_data["availableTo"].toString()) : <any>undefined;
            this.schoolYear = _data["schoolYear"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["gradeLevelId"] = this.gradeLevelId;
        data["gradeLevel"] = this.gradeLevel;
        data["isActive"] = this.isActive;
        data["educationLevel"] = this.educationLevel;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : <any>undefined;
        data["availableTo"] = this.availableTo ? this.availableTo.toISOString() : <any>undefined;
        data["schoolYear"] = this.schoolYear;
        data["id"] = this.id;
        return data; 
    }

    clone(): CourseDto {
        const json = this.toJSON();
        let result = new CourseDto();
        result.init(json);
        return result;
    }
}

export interface ICourseDto {
    name: string | undefined;
    description: string | undefined;
    gradeLevelId: string | undefined;
    gradeLevel: string | undefined;
    isActive: boolean;
    educationLevel: EducationLevelKind;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    schoolYear: string | undefined;
    id: number;
}

export class CreateCourseRequest implements ICreateCourseRequest {
    course: CourseDto;

    constructor(data?: ICreateCourseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.course = _data["course"] ? CourseDto.fromJS(_data["course"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCourseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCourseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["course"] = this.course ? this.course.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CreateCourseRequest {
        const json = this.toJSON();
        let result = new CreateCourseRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateCourseRequest {
    course: CourseDto;
}

export class UpdateCourseRequest implements IUpdateCourseRequest {
    course: CourseDto;

    constructor(data?: IUpdateCourseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.course = _data["course"] ? CourseDto.fromJS(_data["course"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCourseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["course"] = this.course ? this.course.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdateCourseRequest {
        const json = this.toJSON();
        let result = new UpdateCourseRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCourseRequest {
    course: CourseDto;
}

export class SubjectDto implements ISubjectDto {
    courseId: number;
    name: string | undefined;
    description: string | undefined;
    previewImage: ImageField;
    iconImage: ImageField;
    tenantId: number;
    id: number;

    constructor(data?: ISubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.previewImage = _data["previewImage"] ? ImageField.fromJS(_data["previewImage"]) : <any>undefined;
            this.iconImage = _data["iconImage"] ? ImageField.fromJS(_data["iconImage"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["previewImage"] = this.previewImage ? this.previewImage.toJSON() : <any>undefined;
        data["iconImage"] = this.iconImage ? this.iconImage.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): SubjectDto {
        const json = this.toJSON();
        let result = new SubjectDto();
        result.init(json);
        return result;
    }
}

export interface ISubjectDto {
    courseId: number;
    name: string | undefined;
    description: string | undefined;
    previewImage: ImageField;
    iconImage: ImageField;
    tenantId: number;
    id: number;
}

export class AssignmentTypeDto implements IAssignmentTypeDto {
    courseId: number;
    name: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IAssignmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssignmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }

    clone(): AssignmentTypeDto {
        const json = this.toJSON();
        let result = new AssignmentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAssignmentTypeDto {
    courseId: number;
    name: string | undefined;
    description: string | undefined;
    id: number;
}

export class AccessLevelDto implements IAccessLevelDto {
    courseId: number;
    name: string | undefined;
    description: string | undefined;
    tenantId: number;
    id: number;

    constructor(data?: IAccessLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AccessLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): AccessLevelDto {
        const json = this.toJSON();
        let result = new AccessLevelDto();
        result.init(json);
        return result;
    }
}

export interface IAccessLevelDto {
    courseId: number;
    name: string | undefined;
    description: string | undefined;
    tenantId: number;
    id: number;
}

export class CourseDetailsDto implements ICourseDetailsDto {
    course: CourseDto;
    subjects: SubjectDto[] | undefined;
    assignmentTypes: AssignmentTypeDto[] | undefined;
    accessLevels: AccessLevelDto[] | undefined;

    constructor(data?: ICourseDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.course = _data["course"] ? CourseDto.fromJS(_data["course"]) : <any>undefined;
            if (Array.isArray(_data["subjects"])) {
                this.subjects = [] as any;
                for (let item of _data["subjects"])
                    this.subjects.push(SubjectDto.fromJS(item));
            }
            if (Array.isArray(_data["assignmentTypes"])) {
                this.assignmentTypes = [] as any;
                for (let item of _data["assignmentTypes"])
                    this.assignmentTypes.push(AssignmentTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["accessLevels"])) {
                this.accessLevels = [] as any;
                for (let item of _data["accessLevels"])
                    this.accessLevels.push(AccessLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["course"] = this.course ? this.course.toJSON() : <any>undefined;
        if (Array.isArray(this.subjects)) {
            data["subjects"] = [];
            for (let item of this.subjects)
                data["subjects"].push(item.toJSON());
        }
        if (Array.isArray(this.assignmentTypes)) {
            data["assignmentTypes"] = [];
            for (let item of this.assignmentTypes)
                data["assignmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.accessLevels)) {
            data["accessLevels"] = [];
            for (let item of this.accessLevels)
                data["accessLevels"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CourseDetailsDto {
        const json = this.toJSON();
        let result = new CourseDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ICourseDetailsDto {
    course: CourseDto;
    subjects: SubjectDto[] | undefined;
    assignmentTypes: AssignmentTypeDto[] | undefined;
    accessLevels: AccessLevelDto[] | undefined;
}

export enum MeetingStatusKind {
    Scheduled = <any>"Scheduled",
    Available = <any>"Available",
    InProgress = <any>"InProgress",
    Completed = <any>"Completed",
}

export class LiveClassDto implements ILiveClassDto {
    courseId: number;
    title: string | undefined;
    description: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
    status: MeetingStatusKind;
    meetingType: string | undefined;
    meetingLink: string | undefined;
    accessLevels: number[] | undefined;
    id: number;

    constructor(data?: ILiveClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.meetingType = _data["meetingType"];
            this.meetingLink = _data["meetingLink"];
            if (Array.isArray(_data["accessLevels"])) {
                this.accessLevels = [] as any;
                for (let item of _data["accessLevels"])
                    this.accessLevels.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiveClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiveClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["meetingType"] = this.meetingType;
        data["meetingLink"] = this.meetingLink;
        if (Array.isArray(this.accessLevels)) {
            data["accessLevels"] = [];
            for (let item of this.accessLevels)
                data["accessLevels"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): LiveClassDto {
        const json = this.toJSON();
        let result = new LiveClassDto();
        result.init(json);
        return result;
    }
}

export interface ILiveClassDto {
    courseId: number;
    title: string | undefined;
    description: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
    status: MeetingStatusKind;
    meetingType: string | undefined;
    meetingLink: string | undefined;
    accessLevels: number[] | undefined;
    id: number;
}

export class PagedResultDtoOfLiveClassDto implements IPagedResultDtoOfLiveClassDto {
    totalCount: number;
    items: LiveClassDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLiveClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LiveClassDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLiveClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLiveClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfLiveClassDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLiveClassDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLiveClassDto {
    totalCount: number;
    items: LiveClassDto[] | undefined;
}

export class CourseSegmentDto implements ICourseSegmentDto {
    courseId: number;
    sectionName: string | undefined;
    sectionNumber: number;
    title: string | undefined;
    segmentNumber: number;
    segmentCode: string | undefined;
    courseSectionId: number;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    publishStatus: PublishStatusKind;
    id: number;

    constructor(data?: ICourseSegmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.sectionName = _data["sectionName"];
            this.sectionNumber = _data["sectionNumber"];
            this.title = _data["title"];
            this.segmentNumber = _data["segmentNumber"];
            this.segmentCode = _data["segmentCode"];
            this.courseSectionId = _data["courseSectionId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.publishStatus = _data["publishStatus"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseSegmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSegmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["sectionName"] = this.sectionName;
        data["sectionNumber"] = this.sectionNumber;
        data["title"] = this.title;
        data["segmentNumber"] = this.segmentNumber;
        data["segmentCode"] = this.segmentCode;
        data["courseSectionId"] = this.courseSectionId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["publishStatus"] = this.publishStatus;
        data["id"] = this.id;
        return data; 
    }

    clone(): CourseSegmentDto {
        const json = this.toJSON();
        let result = new CourseSegmentDto();
        result.init(json);
        return result;
    }
}

export interface ICourseSegmentDto {
    courseId: number;
    sectionName: string | undefined;
    sectionNumber: number;
    title: string | undefined;
    segmentNumber: number;
    segmentCode: string | undefined;
    courseSectionId: number;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    publishStatus: PublishStatusKind;
    id: number;
}

export class PagedResultDtoOfCourseSegmentDto implements IPagedResultDtoOfCourseSegmentDto {
    totalCount: number;
    items: CourseSegmentDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCourseSegmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CourseSegmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCourseSegmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCourseSegmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfCourseSegmentDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCourseSegmentDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCourseSegmentDto {
    totalCount: number;
    items: CourseSegmentDto[] | undefined;
}

export class SearchImageMediaRequest implements ISearchImageMediaRequest {
    searchText: string | undefined;
    pageNumber: number;
    pageSize: number;

    constructor(data?: ISearchImageMediaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): SearchImageMediaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchImageMediaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data; 
    }

    clone(): SearchImageMediaRequest {
        const json = this.toJSON();
        let result = new SearchImageMediaRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchImageMediaRequest {
    searchText: string | undefined;
    pageNumber: number;
    pageSize: number;
}

export enum ImageAnchorLocation {
    TopLeft = <any>"TopLeft",
    TopCenter = <any>"TopCenter",
    TopRight = <any>"TopRight",
    MiddleLeft = <any>"MiddleLeft",
    MiddleCenter = <any>"MiddleCenter",
    MiddleRight = <any>"MiddleRight",
    BottomLeft = <any>"BottomLeft",
    BottomCenter = <any>"BottomCenter",
    BottomRight = <any>"BottomRight",
}

export class ImageMediaDto implements IImageMediaDto {
    id: number;
    fileName: string | undefined;
    fileNameOnDisk: string | undefined;
    fileExtension: string | undefined;
    width: number;
    height: number;
    title: string | undefined;
    fileUpdateDate: moment.Moment;
    defaultAnchorLocation: ImageAnchorLocation;
    url: string | undefined;
    creationTime: moment.Moment;
    fileSizeInBytes: number;

    constructor(data?: IImageMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileNameOnDisk = _data["fileNameOnDisk"];
            this.fileExtension = _data["fileExtension"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.title = _data["title"];
            this.fileUpdateDate = _data["fileUpdateDate"] ? moment(_data["fileUpdateDate"].toString()) : <any>undefined;
            this.defaultAnchorLocation = _data["defaultAnchorLocation"];
            this.url = _data["url"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.fileSizeInBytes = _data["fileSizeInBytes"];
        }
    }

    static fromJS(data: any): ImageMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileNameOnDisk"] = this.fileNameOnDisk;
        data["fileExtension"] = this.fileExtension;
        data["width"] = this.width;
        data["height"] = this.height;
        data["title"] = this.title;
        data["fileUpdateDate"] = this.fileUpdateDate ? this.fileUpdateDate.toISOString() : <any>undefined;
        data["defaultAnchorLocation"] = this.defaultAnchorLocation;
        data["url"] = this.url;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["fileSizeInBytes"] = this.fileSizeInBytes;
        return data; 
    }

    clone(): ImageMediaDto {
        const json = this.toJSON();
        let result = new ImageMediaDto();
        result.init(json);
        return result;
    }
}

export interface IImageMediaDto {
    id: number;
    fileName: string | undefined;
    fileNameOnDisk: string | undefined;
    fileExtension: string | undefined;
    width: number;
    height: number;
    title: string | undefined;
    fileUpdateDate: moment.Moment;
    defaultAnchorLocation: ImageAnchorLocation;
    url: string | undefined;
    creationTime: moment.Moment;
    fileSizeInBytes: number;
}

export class SearchImageMediaResponse implements ISearchImageMediaResponse {
    items: ImageMediaDto[] | undefined;

    constructor(data?: ISearchImageMediaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ImageMediaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchImageMediaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchImageMediaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SearchImageMediaResponse {
        const json = this.toJSON();
        let result = new SearchImageMediaResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchImageMediaResponse {
    items: ImageMediaDto[] | undefined;
}

export class LessonDto implements ILessonDto {
    title: string | undefined;
    description: string | undefined;
    courseId: number;
    subjectId: number | undefined;
    subject: string | undefined;
    previewImage: ImageField;
    id: string;

    constructor(data?: ILessonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.courseId = _data["courseId"];
            this.subjectId = _data["subjectId"];
            this.subject = _data["subject"];
            this.previewImage = _data["previewImage"] ? ImageField.fromJS(_data["previewImage"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LessonDto {
        data = typeof data === 'object' ? data : {};
        let result = new LessonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["courseId"] = this.courseId;
        data["subjectId"] = this.subjectId;
        data["subject"] = this.subject;
        data["previewImage"] = this.previewImage ? this.previewImage.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): LessonDto {
        const json = this.toJSON();
        let result = new LessonDto();
        result.init(json);
        return result;
    }
}

export interface ILessonDto {
    title: string | undefined;
    description: string | undefined;
    courseId: number;
    subjectId: number | undefined;
    subject: string | undefined;
    previewImage: ImageField;
    id: string;
}

export class LessonDetailDto implements ILessonDetailDto {
    lesson: LessonDto;
    activities: ActivityDto[] | undefined;

    constructor(data?: ILessonDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lesson = _data["lesson"] ? LessonDto.fromJS(_data["lesson"]) : <any>undefined;
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(ActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LessonDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new LessonDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lesson"] = this.lesson ? this.lesson.toJSON() : <any>undefined;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        return data; 
    }

    clone(): LessonDetailDto {
        const json = this.toJSON();
        let result = new LessonDetailDto();
        result.init(json);
        return result;
    }
}

export interface ILessonDetailDto {
    lesson: LessonDto;
    activities: ActivityDto[] | undefined;
}

export class PagedResultDtoOfLessonDto implements IPagedResultDtoOfLessonDto {
    totalCount: number;
    items: LessonDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLessonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LessonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLessonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLessonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfLessonDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLessonDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLessonDto {
    totalCount: number;
    items: LessonDto[] | undefined;
}

export class MediaFolderDto implements IMediaFolderDto {
    parentId: string | undefined;
    name: string | undefined;
    isRoot: boolean;
    tenantId: number;
    description: string | undefined;
    expanded: boolean;
    isSelected: boolean;
    subFolders: MediaFolderDto[] | undefined;
    id: string;

    constructor(data?: IMediaFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.isRoot = _data["isRoot"];
            this.tenantId = _data["tenantId"];
            this.description = _data["description"];
            this.expanded = _data["expanded"];
            this.isSelected = _data["isSelected"];
            if (Array.isArray(_data["subFolders"])) {
                this.subFolders = [] as any;
                for (let item of _data["subFolders"])
                    this.subFolders.push(MediaFolderDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MediaFolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaFolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["isRoot"] = this.isRoot;
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["expanded"] = this.expanded;
        data["isSelected"] = this.isSelected;
        if (Array.isArray(this.subFolders)) {
            data["subFolders"] = [];
            for (let item of this.subFolders)
                data["subFolders"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): MediaFolderDto {
        const json = this.toJSON();
        let result = new MediaFolderDto();
        result.init(json);
        return result;
    }
}

export interface IMediaFolderDto {
    parentId: string | undefined;
    name: string | undefined;
    isRoot: boolean;
    tenantId: number;
    description: string | undefined;
    expanded: boolean;
    isSelected: boolean;
    subFolders: MediaFolderDto[] | undefined;
    id: string;
}

export class SearchFolderImagesRequest implements ISearchFolderImagesRequest {
    searchText: string | undefined;
    pageNumber: number;
    pageSize: number;

    constructor(data?: ISearchFolderImagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): SearchFolderImagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFolderImagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data; 
    }

    clone(): SearchFolderImagesRequest {
        const json = this.toJSON();
        let result = new SearchFolderImagesRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchFolderImagesRequest {
    searchText: string | undefined;
    pageNumber: number;
    pageSize: number;
}

export class AddMediaFolderRequest implements IAddMediaFolderRequest {
    parentId: string;
    folderName: string | undefined;

    constructor(data?: IAddMediaFolderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.folderName = _data["folderName"];
        }
    }

    static fromJS(data: any): AddMediaFolderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMediaFolderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["folderName"] = this.folderName;
        return data; 
    }

    clone(): AddMediaFolderRequest {
        const json = this.toJSON();
        let result = new AddMediaFolderRequest();
        result.init(json);
        return result;
    }
}

export interface IAddMediaFolderRequest {
    parentId: string;
    folderName: string | undefined;
}

export class EditMediaFolderRequest implements IEditMediaFolderRequest {
    folderId: string;
    name: string | undefined;

    constructor(data?: IEditMediaFolderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderId = _data["folderId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EditMediaFolderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditMediaFolderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderId"] = this.folderId;
        data["name"] = this.name;
        return data; 
    }

    clone(): EditMediaFolderRequest {
        const json = this.toJSON();
        let result = new EditMediaFolderRequest();
        result.init(json);
        return result;
    }
}

export interface IEditMediaFolderRequest {
    folderId: string;
    name: string | undefined;
}

export class PresentationActivityDto implements IPresentationActivityDto {
    courseId: number;
    activityId: string;
    url: string | undefined;
    fileUploaded: boolean;
    reportsResults: boolean;
    quizzes: number;

    constructor(data?: IPresentationActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.activityId = _data["activityId"];
            this.url = _data["url"];
            this.fileUploaded = _data["fileUploaded"];
            this.reportsResults = _data["reportsResults"];
            this.quizzes = _data["quizzes"];
        }
    }

    static fromJS(data: any): PresentationActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PresentationActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["activityId"] = this.activityId;
        data["url"] = this.url;
        data["fileUploaded"] = this.fileUploaded;
        data["reportsResults"] = this.reportsResults;
        data["quizzes"] = this.quizzes;
        return data; 
    }

    clone(): PresentationActivityDto {
        const json = this.toJSON();
        let result = new PresentationActivityDto();
        result.init(json);
        return result;
    }
}

export interface IPresentationActivityDto {
    courseId: number;
    activityId: string;
    url: string | undefined;
    fileUploaded: boolean;
    reportsResults: boolean;
    quizzes: number;
}

export enum GradeAttemptMode {
    FirstAttempt = <any>"FirstAttempt",
    HighestGrade = <any>"HighestGrade",
    LastAttempt = <any>"LastAttempt",
    Average = <any>"Average",
    LowestGrade = <any>"LowestGrade",
}

export enum GradeTypeKind {
    Percentage = <any>"Percentage",
    Points = <any>"Points",
    Letter = <any>"Letter",
    Stars = <any>"Stars",
}

export class QuizDto implements IQuizDto {
    isTimed: boolean;
    timeLimit: number | undefined;
    attemptsAllowed: number | undefined;
    gradeAttempt: GradeAttemptMode;
    gradeUsing: GradeTypeKind;
    maximumPoints: number | undefined;
    defaultChoices: number | undefined;
    assignmentType: string | undefined;
    tenantId: number;
    showProgress: boolean;
    markerMode: MarkerModeKind;
    subjectId: number | undefined;
    id: string;

    constructor(data?: IQuizDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTimed = _data["isTimed"];
            this.timeLimit = _data["timeLimit"];
            this.attemptsAllowed = _data["attemptsAllowed"];
            this.gradeAttempt = _data["gradeAttempt"];
            this.gradeUsing = _data["gradeUsing"];
            this.maximumPoints = _data["maximumPoints"];
            this.defaultChoices = _data["defaultChoices"];
            this.assignmentType = _data["assignmentType"];
            this.tenantId = _data["tenantId"];
            this.showProgress = _data["showProgress"];
            this.markerMode = _data["markerMode"];
            this.subjectId = _data["subjectId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QuizDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTimed"] = this.isTimed;
        data["timeLimit"] = this.timeLimit;
        data["attemptsAllowed"] = this.attemptsAllowed;
        data["gradeAttempt"] = this.gradeAttempt;
        data["gradeUsing"] = this.gradeUsing;
        data["maximumPoints"] = this.maximumPoints;
        data["defaultChoices"] = this.defaultChoices;
        data["assignmentType"] = this.assignmentType;
        data["tenantId"] = this.tenantId;
        data["showProgress"] = this.showProgress;
        data["markerMode"] = this.markerMode;
        data["subjectId"] = this.subjectId;
        data["id"] = this.id;
        return data; 
    }

    clone(): QuizDto {
        const json = this.toJSON();
        let result = new QuizDto();
        result.init(json);
        return result;
    }
}

export interface IQuizDto {
    isTimed: boolean;
    timeLimit: number | undefined;
    attemptsAllowed: number | undefined;
    gradeAttempt: GradeAttemptMode;
    gradeUsing: GradeTypeKind;
    maximumPoints: number | undefined;
    defaultChoices: number | undefined;
    assignmentType: string | undefined;
    tenantId: number;
    showProgress: boolean;
    markerMode: MarkerModeKind;
    subjectId: number | undefined;
    id: string;
}

export class QuizEditPageDto implements IQuizEditPageDto {
    quizId: string;
    title: string | undefined;
    itemIndex: number;
    id: string;

    constructor(data?: IQuizEditPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quizId = _data["quizId"];
            this.title = _data["title"];
            this.itemIndex = _data["itemIndex"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QuizEditPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizEditPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quizId"] = this.quizId;
        data["title"] = this.title;
        data["itemIndex"] = this.itemIndex;
        data["id"] = this.id;
        return data; 
    }

    clone(): QuizEditPageDto {
        const json = this.toJSON();
        let result = new QuizEditPageDto();
        result.init(json);
        return result;
    }
}

export interface IQuizEditPageDto {
    quizId: string;
    title: string | undefined;
    itemIndex: number;
    id: string;
}

export class QuizActivityDto implements IQuizActivityDto {
    courseId: number;
    activityId: string;
    quiz: QuizDto;
    pages: QuizEditPageDto[] | undefined;

    constructor(data?: IQuizActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.activityId = _data["activityId"];
            this.quiz = _data["quiz"] ? QuizDto.fromJS(_data["quiz"]) : <any>undefined;
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages.push(QuizEditPageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuizActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["activityId"] = this.activityId;
        data["quiz"] = this.quiz ? this.quiz.toJSON() : <any>undefined;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data; 
    }

    clone(): QuizActivityDto {
        const json = this.toJSON();
        let result = new QuizActivityDto();
        result.init(json);
        return result;
    }
}

export interface IQuizActivityDto {
    courseId: number;
    activityId: string;
    quiz: QuizDto;
    pages: QuizEditPageDto[] | undefined;
}

export class RemarkQuizRequest implements IRemarkQuizRequest {
    quizId: string;

    constructor(data?: IRemarkQuizRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quizId = _data["quizId"];
        }
    }

    static fromJS(data: any): RemarkQuizRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemarkQuizRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quizId"] = this.quizId;
        return data; 
    }

    clone(): RemarkQuizRequest {
        const json = this.toJSON();
        let result = new RemarkQuizRequest();
        result.init(json);
        return result;
    }
}

export interface IRemarkQuizRequest {
    quizId: string;
}

export class MarkQuizAttempts implements IMarkQuizAttempts {

    constructor(data?: IMarkQuizAttempts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MarkQuizAttempts {
        data = typeof data === 'object' ? data : {};
        let result = new MarkQuizAttempts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): MarkQuizAttempts {
        const json = this.toJSON();
        let result = new MarkQuizAttempts();
        result.init(json);
        return result;
    }
}

export interface IMarkQuizAttempts {
}

export class ReturnQuizAttemptInput implements IReturnQuizAttemptInput {
    attemptId: string;
    readonly id: string;

    constructor(data?: IReturnQuizAttemptInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attemptId = _data["attemptId"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): ReturnQuizAttemptInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnQuizAttemptInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attemptId"] = this.attemptId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ReturnQuizAttemptInput {
        const json = this.toJSON();
        let result = new ReturnQuizAttemptInput();
        result.init(json);
        return result;
    }
}

export interface IReturnQuizAttemptInput {
    attemptId: string;
    id: string;
}

export class CopyQuizInput implements ICopyQuizInput {
    courseActivityId: string;
    toCourseId: number;
    readonly id: string;

    constructor(data?: ICopyQuizInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseActivityId = _data["courseActivityId"];
            this.toCourseId = _data["toCourseId"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): CopyQuizInput {
        data = typeof data === 'object' ? data : {};
        let result = new CopyQuizInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseActivityId"] = this.courseActivityId;
        data["toCourseId"] = this.toCourseId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CopyQuizInput {
        const json = this.toJSON();
        let result = new CopyQuizInput();
        result.init(json);
        return result;
    }
}

export interface ICopyQuizInput {
    courseActivityId: string;
    toCourseId: number;
    id: string;
}

export class ScoreResult implements IScoreResult {
    percentageScore: number;
    pointScore: number;
    totalPoints: number;

    constructor(data?: IScoreResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentageScore = _data["percentageScore"];
            this.pointScore = _data["pointScore"];
            this.totalPoints = _data["totalPoints"];
        }
    }

    static fromJS(data: any): ScoreResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentageScore"] = this.percentageScore;
        data["pointScore"] = this.pointScore;
        data["totalPoints"] = this.totalPoints;
        return data; 
    }

    clone(): ScoreResult {
        const json = this.toJSON();
        let result = new ScoreResult();
        result.init(json);
        return result;
    }
}

export interface IScoreResult {
    percentageScore: number;
    pointScore: number;
    totalPoints: number;
}

export class FeedbackResult implements IFeedbackResult {
    imageId: number;
    imageUrl: string | undefined;
    starRating: number;
    title: string | undefined;
    comments: string | undefined;

    constructor(data?: IFeedbackResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.imageUrl = _data["imageUrl"];
            this.starRating = _data["starRating"];
            this.title = _data["title"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): FeedbackResult {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["imageUrl"] = this.imageUrl;
        data["starRating"] = this.starRating;
        data["title"] = this.title;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): FeedbackResult {
        const json = this.toJSON();
        let result = new FeedbackResult();
        result.init(json);
        return result;
    }
}

export interface IFeedbackResult {
    imageId: number;
    imageUrl: string | undefined;
    starRating: number;
    title: string | undefined;
    comments: string | undefined;
}

export class QuizAttemptDto implements IQuizAttemptDto {
    gradePercentage: number;
    score: ScoreResult;
    feedback: FeedbackResult;
    submittedTime: moment.Moment | undefined;
    attemptStatus: AttemptStatusKind;
    isCompleted: boolean;
    correct: number | undefined;
    incorrect: number | undefined;
    notAttempted: number | undefined;
    partiallyCorrect: number | undefined;
    id: string;

    constructor(data?: IQuizAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gradePercentage = _data["gradePercentage"];
            this.score = _data["score"] ? ScoreResult.fromJS(_data["score"]) : <any>undefined;
            this.feedback = _data["feedback"] ? FeedbackResult.fromJS(_data["feedback"]) : <any>undefined;
            this.submittedTime = _data["submittedTime"] ? moment(_data["submittedTime"].toString()) : <any>undefined;
            this.attemptStatus = _data["attemptStatus"];
            this.isCompleted = _data["isCompleted"];
            this.correct = _data["correct"];
            this.incorrect = _data["incorrect"];
            this.notAttempted = _data["notAttempted"];
            this.partiallyCorrect = _data["partiallyCorrect"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QuizAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gradePercentage"] = this.gradePercentage;
        data["score"] = this.score ? this.score.toJSON() : <any>undefined;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["submittedTime"] = this.submittedTime ? this.submittedTime.toISOString() : <any>undefined;
        data["attemptStatus"] = this.attemptStatus;
        data["isCompleted"] = this.isCompleted;
        data["correct"] = this.correct;
        data["incorrect"] = this.incorrect;
        data["notAttempted"] = this.notAttempted;
        data["partiallyCorrect"] = this.partiallyCorrect;
        data["id"] = this.id;
        return data; 
    }

    clone(): QuizAttemptDto {
        const json = this.toJSON();
        let result = new QuizAttemptDto();
        result.init(json);
        return result;
    }
}

export interface IQuizAttemptDto {
    gradePercentage: number;
    score: ScoreResult;
    feedback: FeedbackResult;
    submittedTime: moment.Moment | undefined;
    attemptStatus: AttemptStatusKind;
    isCompleted: boolean;
    correct: number | undefined;
    incorrect: number | undefined;
    notAttempted: number | undefined;
    partiallyCorrect: number | undefined;
    id: string;
}

export enum ContentLayoutKind {
    TextOnly = <any>"TextOnly",
    ImageLeft = <any>"ImageLeft",
    ImageTop = <any>"ImageTop",
    ImageRight = <any>"ImageRight",
    ImageBottom = <any>"ImageBottom",
    ImageOnly = <any>"ImageOnly",
    None = <any>"None",
}

export enum TextFormatKind {
    Plain = <any>"Plain",
    Html = <any>"Html",
    Markdown = <any>"Markdown",
}

export class Block implements IBlock {
    colSpan: number;
    type: string | undefined;

    protected _discriminator: string;

    constructor(data?: IBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "Block";
    }

    init(_data?: any) {
        if (_data) {
            this.colSpan = _data["colSpan"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Block {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "SimpleContentBlock") {
            let result = new SimpleContentBlock();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ColumnBlock") {
            let result = new ColumnBlock();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BlockGroup") {
            let result = new BlockGroup();
            result.init(data);
            return result;
        }
        if (data["$type"] === "HtmlBlock") {
            let result = new HtmlBlock();
            result.init(data);
            return result;
        }
        if (data["$type"] === "HtmlColumnBlock") {
            let result = new HtmlColumnBlock();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextBlock") {
            let result = new TextBlock();
            result.init(data);
            return result;
        }
        let result = new Block();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["colSpan"] = this.colSpan;
        data["type"] = this.type;
        return data; 
    }

    clone(): Block {
        const json = this.toJSON();
        let result = new Block();
        result.init(json);
        return result;
    }
}

export interface IBlock {
    colSpan: number;
    type: string | undefined;
}

export class SimpleContentBlock extends Block implements ISimpleContentBlock {
    text: string | undefined;
    image: ImageField;
    title: string | undefined;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;

    constructor(data?: ISimpleContentBlock) {
        super(data);
        this._discriminator = "SimpleContentBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.title = _data["title"];
            this.layout = _data["layout"];
            this.textFormat = _data["textFormat"];
        }
    }

    static fromJS(data: any): SimpleContentBlock {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleContentBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["layout"] = this.layout;
        data["textFormat"] = this.textFormat;
        super.toJSON(data);
        return data; 
    }

    clone(): SimpleContentBlock {
        const json = this.toJSON();
        let result = new SimpleContentBlock();
        result.init(json);
        return result;
    }
}

export interface ISimpleContentBlock extends IBlock {
    text: string | undefined;
    image: ImageField;
    title: string | undefined;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;
}

export class ChoiceDto implements IChoiceDto {
    name: string | undefined;
    readonly key: string | undefined;
    index: number;
    isCorrect: boolean;
    image: ImageField;
    text: string | undefined;

    constructor(data?: IChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            (<any>this).key = _data["key"];
            this.index = _data["index"];
            this.isCorrect = _data["isCorrect"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["key"] = this.key;
        data["index"] = this.index;
        data["isCorrect"] = this.isCorrect;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["text"] = this.text;
        return data; 
    }

    clone(): ChoiceDto {
        const json = this.toJSON();
        let result = new ChoiceDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceDto {
    name: string | undefined;
    key: string | undefined;
    index: number;
    isCorrect: boolean;
    image: ImageField;
    text: string | undefined;
}

export enum ChoiceKind {
    Single = <any>"Single",
    Multiple = <any>"Multiple",
    Any = <any>"Any",
}

export class ChoiceGroupDto implements IChoiceGroupDto {
    values: ChoiceDto[] | undefined;
    choiceType: ChoiceKind;
    columns: number;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;

    constructor(data?: IChoiceGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(ChoiceDto.fromJS(item));
            }
            this.choiceType = _data["choiceType"];
            this.columns = _data["columns"];
            this.layout = _data["layout"];
            this.textFormat = _data["textFormat"];
        }
    }

    static fromJS(data: any): ChoiceGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["choiceType"] = this.choiceType;
        data["columns"] = this.columns;
        data["layout"] = this.layout;
        data["textFormat"] = this.textFormat;
        return data; 
    }

    clone(): ChoiceGroupDto {
        const json = this.toJSON();
        let result = new ChoiceGroupDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceGroupDto {
    values: ChoiceDto[] | undefined;
    choiceType: ChoiceKind;
    columns: number;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;
}

export class Hint implements IHint {
    content: SimpleContentBlock;

    constructor(data?: IHint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Hint {
        data = typeof data === 'object' ? data : {};
        let result = new Hint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data; 
    }

    clone(): Hint {
        const json = this.toJSON();
        let result = new Hint();
        result.init(json);
        return result;
    }
}

export interface IHint {
    content: SimpleContentBlock;
}

export class ProblemDto implements IProblemDto {
    isReadOnly: boolean;
    solution: SimpleContentBlock;
    hints: Hint[] | undefined;
    type: string | undefined;

    protected _discriminator: string;

    constructor(data?: IProblemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ProblemDto";
    }

    init(_data?: any) {
        if (_data) {
            this.isReadOnly = _data["isReadOnly"];
            this.solution = _data["solution"] ? SimpleContentBlock.fromJS(_data["solution"]) : <any>undefined;
            if (Array.isArray(_data["hints"])) {
                this.hints = [] as any;
                for (let item of _data["hints"])
                    this.hints.push(Hint.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ProblemDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MultiChoiceProblemDto") {
            let result = new MultiChoiceProblemDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MultiEntryProblemDto") {
            let result = new MultiEntryProblemDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextInputProblemDto") {
            let result = new TextInputProblemDto();
            result.init(data);
            return result;
        }
        let result = new ProblemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["isReadOnly"] = this.isReadOnly;
        data["solution"] = this.solution ? this.solution.toJSON() : <any>undefined;
        if (Array.isArray(this.hints)) {
            data["hints"] = [];
            for (let item of this.hints)
                data["hints"].push(item.toJSON());
        }
        data["type"] = this.type;
        return data; 
    }

    clone(): ProblemDto {
        const json = this.toJSON();
        let result = new ProblemDto();
        result.init(json);
        return result;
    }
}

export interface IProblemDto {
    isReadOnly: boolean;
    solution: SimpleContentBlock;
    hints: Hint[] | undefined;
    type: string | undefined;
}

export class MultiChoiceProblemDto extends ProblemDto implements IMultiChoiceProblemDto {
    content: SimpleContentBlock;
    choices: ChoiceGroupDto;

    constructor(data?: IMultiChoiceProblemDto) {
        super(data);
        this._discriminator = "MultiChoiceProblemDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            this.choices = _data["choices"] ? ChoiceGroupDto.fromJS(_data["choices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MultiChoiceProblemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiChoiceProblemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["choices"] = this.choices ? this.choices.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): MultiChoiceProblemDto {
        const json = this.toJSON();
        let result = new MultiChoiceProblemDto();
        result.init(json);
        return result;
    }
}

export interface IMultiChoiceProblemDto extends IProblemDto {
    content: SimpleContentBlock;
    choices: ChoiceGroupDto;
}

export enum SegmentKind {
    Text = <any>"Text",
    Field = <any>"Field",
}

export class TextSegment implements ITextSegment {
    text: string | undefined;
    fieldKey: string | undefined;
    segmentType: SegmentKind;

    constructor(data?: ITextSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.fieldKey = _data["fieldKey"];
            this.segmentType = _data["segmentType"];
        }
    }

    static fromJS(data: any): TextSegment {
        data = typeof data === 'object' ? data : {};
        let result = new TextSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["fieldKey"] = this.fieldKey;
        data["segmentType"] = this.segmentType;
        return data; 
    }

    clone(): TextSegment {
        const json = this.toJSON();
        let result = new TextSegment();
        result.init(json);
        return result;
    }
}

export interface ITextSegment {
    text: string | undefined;
    fieldKey: string | undefined;
    segmentType: SegmentKind;
}

export enum MultiEntryType {
    FillBlank = <any>"FillBlank",
    SimpleInput = <any>"SimpleInput",
    EntryGridItem = <any>"EntryGridItem",
}

export enum EntryFieldKind {
    TextInput = <any>"TextInput",
    TextArea = <any>"TextArea",
    NumericInput = <any>"NumericInput",
    Dropdown = <any>"Dropdown",
    MultipleChoice = <any>"MultipleChoice",
    NoEntry = <any>"NoEntry",
}

export class EntryAnswer implements IEntryAnswer {
    value: string | undefined;

    constructor(data?: IEntryAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EntryAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new EntryAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data; 
    }

    clone(): EntryAnswer {
        const json = this.toJSON();
        let result = new EntryAnswer();
        result.init(json);
        return result;
    }
}

export interface IEntryAnswer {
    value: string | undefined;
}

export class EntryFieldDto implements IEntryFieldDto {
    textSegments: TextSegment[] | undefined;
    key: string | undefined;
    value: string | undefined;
    displayWidth: number;
    entryType: EntryFieldKind;
    layoutTemplate: string | undefined;
    text: string | undefined;
    image: ImageField;
    textFormat: TextFormatKind;
    choices: ChoiceGroupDto;
    answer: string | undefined;
    answers: EntryAnswer[] | undefined;
    index: number;
    hasSegments: boolean;

    constructor(data?: IEntryFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["textSegments"])) {
                this.textSegments = [] as any;
                for (let item of _data["textSegments"])
                    this.textSegments.push(TextSegment.fromJS(item));
            }
            this.key = _data["key"];
            this.value = _data["value"];
            this.displayWidth = _data["displayWidth"];
            this.entryType = _data["entryType"];
            this.layoutTemplate = _data["layoutTemplate"];
            this.text = _data["text"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.textFormat = _data["textFormat"];
            this.choices = _data["choices"] ? ChoiceGroupDto.fromJS(_data["choices"]) : <any>undefined;
            this.answer = _data["answer"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers.push(EntryAnswer.fromJS(item));
            }
            this.index = _data["index"];
            this.hasSegments = _data["hasSegments"];
        }
    }

    static fromJS(data: any): EntryFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntryFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.textSegments)) {
            data["textSegments"] = [];
            for (let item of this.textSegments)
                data["textSegments"].push(item.toJSON());
        }
        data["key"] = this.key;
        data["value"] = this.value;
        data["displayWidth"] = this.displayWidth;
        data["entryType"] = this.entryType;
        data["layoutTemplate"] = this.layoutTemplate;
        data["text"] = this.text;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["textFormat"] = this.textFormat;
        data["choices"] = this.choices ? this.choices.toJSON() : <any>undefined;
        data["answer"] = this.answer;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["index"] = this.index;
        data["hasSegments"] = this.hasSegments;
        return data; 
    }

    clone(): EntryFieldDto {
        const json = this.toJSON();
        let result = new EntryFieldDto();
        result.init(json);
        return result;
    }
}

export interface IEntryFieldDto {
    textSegments: TextSegment[] | undefined;
    key: string | undefined;
    value: string | undefined;
    displayWidth: number;
    entryType: EntryFieldKind;
    layoutTemplate: string | undefined;
    text: string | undefined;
    image: ImageField;
    textFormat: TextFormatKind;
    choices: ChoiceGroupDto;
    answer: string | undefined;
    answers: EntryAnswer[] | undefined;
    index: number;
    hasSegments: boolean;
}

export class MultiEntryProblemDto extends ProblemDto implements IMultiEntryProblemDto {
    textSegments: TextSegment[] | undefined;
    entryType: MultiEntryType;
    content: SimpleContentBlock;
    fields: EntryFieldDto[] | undefined;
    hasSegments: boolean;

    constructor(data?: IMultiEntryProblemDto) {
        super(data);
        this._discriminator = "MultiEntryProblemDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["textSegments"])) {
                this.textSegments = [] as any;
                for (let item of _data["textSegments"])
                    this.textSegments.push(TextSegment.fromJS(item));
            }
            this.entryType = _data["entryType"];
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields.push(EntryFieldDto.fromJS(item));
            }
            this.hasSegments = _data["hasSegments"];
        }
    }

    static fromJS(data: any): MultiEntryProblemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiEntryProblemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.textSegments)) {
            data["textSegments"] = [];
            for (let item of this.textSegments)
                data["textSegments"].push(item.toJSON());
        }
        data["entryType"] = this.entryType;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["hasSegments"] = this.hasSegments;
        super.toJSON(data);
        return data; 
    }

    clone(): MultiEntryProblemDto {
        const json = this.toJSON();
        let result = new MultiEntryProblemDto();
        result.init(json);
        return result;
    }
}

export interface IMultiEntryProblemDto extends IProblemDto {
    textSegments: TextSegment[] | undefined;
    entryType: MultiEntryType;
    content: SimpleContentBlock;
    fields: EntryFieldDto[] | undefined;
    hasSegments: boolean;
}

export class GridColumn implements IGridColumn {
    label: string | undefined;
    image: ImageField;
    choiceName: string | undefined;
    index: number;

    constructor(data?: IGridColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.choiceName = _data["choiceName"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): GridColumn {
        data = typeof data === 'object' ? data : {};
        let result = new GridColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["choiceName"] = this.choiceName;
        data["index"] = this.index;
        return data; 
    }

    clone(): GridColumn {
        const json = this.toJSON();
        let result = new GridColumn();
        result.init(json);
        return result;
    }
}

export interface IGridColumn {
    label: string | undefined;
    image: ImageField;
    choiceName: string | undefined;
    index: number;
}

export class MultiChoiceGrid implements IMultiChoiceGrid {
    content: SimpleContentBlock;
    labelColumn: GridColumn;
    answerColumns: GridColumn[] | undefined;
    colSpan: number;
    type: string | undefined;

    constructor(data?: IMultiChoiceGrid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            this.labelColumn = _data["labelColumn"] ? GridColumn.fromJS(_data["labelColumn"]) : <any>undefined;
            if (Array.isArray(_data["answerColumns"])) {
                this.answerColumns = [] as any;
                for (let item of _data["answerColumns"])
                    this.answerColumns.push(GridColumn.fromJS(item));
            }
            this.colSpan = _data["colSpan"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): MultiChoiceGrid {
        data = typeof data === 'object' ? data : {};
        let result = new MultiChoiceGrid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["labelColumn"] = this.labelColumn ? this.labelColumn.toJSON() : <any>undefined;
        if (Array.isArray(this.answerColumns)) {
            data["answerColumns"] = [];
            for (let item of this.answerColumns)
                data["answerColumns"].push(item.toJSON());
        }
        data["colSpan"] = this.colSpan;
        data["type"] = this.type;
        return data; 
    }

    clone(): MultiChoiceGrid {
        const json = this.toJSON();
        let result = new MultiChoiceGrid();
        result.init(json);
        return result;
    }
}

export interface IMultiChoiceGrid {
    content: SimpleContentBlock;
    labelColumn: GridColumn;
    answerColumns: GridColumn[] | undefined;
    colSpan: number;
    type: string | undefined;
}

export class TextInputProblemDto extends ProblemDto implements ITextInputProblemDto {
    content: SimpleContentBlock;
    lines: number;

    constructor(data?: ITextInputProblemDto) {
        super(data);
        this._discriminator = "TextInputProblemDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            this.lines = _data["lines"];
        }
    }

    static fromJS(data: any): TextInputProblemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextInputProblemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["lines"] = this.lines;
        super.toJSON(data);
        return data; 
    }

    clone(): TextInputProblemDto {
        const json = this.toJSON();
        let result = new TextInputProblemDto();
        result.init(json);
        return result;
    }
}

export interface ITextInputProblemDto extends IProblemDto {
    content: SimpleContentBlock;
    lines: number;
}

export class ScoreRule implements IScoreRule {
    isScored: boolean;
    points: number;
    weight: number;

    constructor(data?: IScoreRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isScored = _data["isScored"];
            this.points = _data["points"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): ScoreRule {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isScored"] = this.isScored;
        data["points"] = this.points;
        data["weight"] = this.weight;
        return data; 
    }

    clone(): ScoreRule {
        const json = this.toJSON();
        let result = new ScoreRule();
        result.init(json);
        return result;
    }
}

export interface IScoreRule {
    isScored: boolean;
    points: number;
    weight: number;
}

export class SimpleFieldOfString implements ISimpleFieldOfString {
    value: string | undefined;

    protected _discriminator: string;

    constructor(data?: ISimpleFieldOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "SimpleFieldOfString";
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SimpleFieldOfString {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "HtmlField") {
            let result = new HtmlField();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextField") {
            let result = new TextField();
            result.init(data);
            return result;
        }
        let result = new SimpleFieldOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["value"] = this.value;
        return data; 
    }

    clone(): SimpleFieldOfString {
        const json = this.toJSON();
        let result = new SimpleFieldOfString();
        result.init(json);
        return result;
    }
}

export interface ISimpleFieldOfString {
    value: string | undefined;
}

export class HtmlField extends SimpleFieldOfString implements IHtmlField {

    constructor(data?: IHtmlField) {
        super(data);
        this._discriminator = "HtmlField";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HtmlField {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): HtmlField {
        const json = this.toJSON();
        let result = new HtmlField();
        result.init(json);
        return result;
    }
}

export interface IHtmlField extends ISimpleFieldOfString {
}

export class HtmlBlock extends Block implements IHtmlBlock {
    body: HtmlField;

    constructor(data?: IHtmlBlock) {
        super(data);
        this._discriminator = "HtmlBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.body = _data["body"] ? HtmlField.fromJS(_data["body"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HtmlBlock {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body ? this.body.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): HtmlBlock {
        const json = this.toJSON();
        let result = new HtmlBlock();
        result.init(json);
        return result;
    }
}

export interface IHtmlBlock extends IBlock {
    body: HtmlField;
}

export class HtmlColumnBlock extends Block implements IHtmlColumnBlock {
    column1: HtmlField;
    column2: HtmlField;

    constructor(data?: IHtmlColumnBlock) {
        super(data);
        this._discriminator = "HtmlColumnBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.column1 = _data["column1"] ? HtmlField.fromJS(_data["column1"]) : <any>undefined;
            this.column2 = _data["column2"] ? HtmlField.fromJS(_data["column2"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HtmlColumnBlock {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlColumnBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column1"] = this.column1 ? this.column1.toJSON() : <any>undefined;
        data["column2"] = this.column2 ? this.column2.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): HtmlColumnBlock {
        const json = this.toJSON();
        let result = new HtmlColumnBlock();
        result.init(json);
        return result;
    }
}

export interface IHtmlColumnBlock extends IBlock {
    column1: HtmlField;
    column2: HtmlField;
}

export class TextField extends SimpleFieldOfString implements ITextField {
    format: TextFormatKind;

    constructor(data?: ITextField) {
        super(data);
        this._discriminator = "TextField";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): TextField {
        data = typeof data === 'object' ? data : {};
        let result = new TextField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        super.toJSON(data);
        return data; 
    }

    clone(): TextField {
        const json = this.toJSON();
        let result = new TextField();
        result.init(json);
        return result;
    }
}

export interface ITextField extends ISimpleFieldOfString {
    format: TextFormatKind;
}

export class TextBlock extends Block implements ITextBlock {
    body: TextField;

    constructor(data?: ITextBlock) {
        super(data);
        this._discriminator = "TextBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.body = _data["body"] ? TextField.fromJS(_data["body"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TextBlock {
        data = typeof data === 'object' ? data : {};
        let result = new TextBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body ? this.body.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): TextBlock {
        const json = this.toJSON();
        let result = new TextBlock();
        result.init(json);
        return result;
    }
}

export interface ITextBlock extends IBlock {
    body: TextField;
}

export class BlockGroup extends Block implements IBlockGroup {
    items: ColumnBlock[] | undefined;

    protected _discriminator: string;

    constructor(data?: IBlockGroup) {
        super(data);
        this._discriminator = "BlockGroup";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ColumnBlock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BlockGroup {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ColumnBlock") {
            let result = new ColumnBlock();
            result.init(data);
            return result;
        }
        let result = new BlockGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): BlockGroup {
        const json = this.toJSON();
        let result = new BlockGroup();
        result.init(json);
        return result;
    }
}

export interface IBlockGroup extends IBlock {
    items: ColumnBlock[] | undefined;
}

export class ColumnBlock extends BlockGroup implements IColumnBlock {
    items: ColumnBlock[] | undefined;
    colSpan: number;
    type: string | undefined;

    constructor(data?: IColumnBlock) {
        super(data);
        this._discriminator = "ColumnBlock";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ColumnBlock.fromJS(item));
            }
            this.colSpan = _data["colSpan"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ColumnBlock {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["colSpan"] = this.colSpan;
        data["type"] = this.type;
        super.toJSON(data);
        return data; 
    }

    clone(): ColumnBlock {
        const json = this.toJSON();
        let result = new ColumnBlock();
        result.init(json);
        return result;
    }
}

export interface IColumnBlock extends IBlockGroup {
    items: ColumnBlock[] | undefined;
    colSpan: number;
    type: string | undefined;
}

export class QuizActivityItemDto implements IQuizActivityItemDto {
    multiChoiceProblem: MultiChoiceProblemDto;
    multiEntryProblem: MultiEntryProblemDto;
    multiChoiceGrid: MultiChoiceGrid;
    textInputProblem: TextInputProblemDto;
    id: string;
    quizId: string;
    pageId: string;
    parentId: string | undefined;
    pageIndex: number;
    itemNumber: number;
    itemIndex: number;
    layoutTemplate: string | undefined;
    isProblem: boolean;
    title: string | undefined;
    colSpan: number;
    scoring: ScoreRule;
    isActive: boolean;
    itemType: string | undefined;
    isGroup: boolean;
    simpleContentBlock: SimpleContentBlock;
    columnBlock: ColumnBlock;
    htmlColumnBlock: HtmlColumnBlock;
    htmlBlock: HtmlBlock;
    textBlock: TextBlock;

    constructor(data?: IQuizActivityItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiChoiceProblem = _data["multiChoiceProblem"] ? MultiChoiceProblemDto.fromJS(_data["multiChoiceProblem"]) : <any>undefined;
            this.multiEntryProblem = _data["multiEntryProblem"] ? MultiEntryProblemDto.fromJS(_data["multiEntryProblem"]) : <any>undefined;
            this.multiChoiceGrid = _data["multiChoiceGrid"] ? MultiChoiceGrid.fromJS(_data["multiChoiceGrid"]) : <any>undefined;
            this.textInputProblem = _data["textInputProblem"] ? TextInputProblemDto.fromJS(_data["textInputProblem"]) : <any>undefined;
            this.id = _data["id"];
            this.quizId = _data["quizId"];
            this.pageId = _data["pageId"];
            this.parentId = _data["parentId"];
            this.pageIndex = _data["pageIndex"];
            this.itemNumber = _data["itemNumber"];
            this.itemIndex = _data["itemIndex"];
            this.layoutTemplate = _data["layoutTemplate"];
            this.isProblem = _data["isProblem"];
            this.title = _data["title"];
            this.colSpan = _data["colSpan"];
            this.scoring = _data["scoring"] ? ScoreRule.fromJS(_data["scoring"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.itemType = _data["itemType"];
            this.isGroup = _data["isGroup"];
            this.simpleContentBlock = _data["simpleContentBlock"] ? SimpleContentBlock.fromJS(_data["simpleContentBlock"]) : <any>undefined;
            this.columnBlock = _data["columnBlock"] ? ColumnBlock.fromJS(_data["columnBlock"]) : <any>undefined;
            this.htmlColumnBlock = _data["htmlColumnBlock"] ? HtmlColumnBlock.fromJS(_data["htmlColumnBlock"]) : <any>undefined;
            this.htmlBlock = _data["htmlBlock"] ? HtmlBlock.fromJS(_data["htmlBlock"]) : <any>undefined;
            this.textBlock = _data["textBlock"] ? TextBlock.fromJS(_data["textBlock"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuizActivityItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizActivityItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiChoiceProblem"] = this.multiChoiceProblem ? this.multiChoiceProblem.toJSON() : <any>undefined;
        data["multiEntryProblem"] = this.multiEntryProblem ? this.multiEntryProblem.toJSON() : <any>undefined;
        data["multiChoiceGrid"] = this.multiChoiceGrid ? this.multiChoiceGrid.toJSON() : <any>undefined;
        data["textInputProblem"] = this.textInputProblem ? this.textInputProblem.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["quizId"] = this.quizId;
        data["pageId"] = this.pageId;
        data["parentId"] = this.parentId;
        data["pageIndex"] = this.pageIndex;
        data["itemNumber"] = this.itemNumber;
        data["itemIndex"] = this.itemIndex;
        data["layoutTemplate"] = this.layoutTemplate;
        data["isProblem"] = this.isProblem;
        data["title"] = this.title;
        data["colSpan"] = this.colSpan;
        data["scoring"] = this.scoring ? this.scoring.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["itemType"] = this.itemType;
        data["isGroup"] = this.isGroup;
        data["simpleContentBlock"] = this.simpleContentBlock ? this.simpleContentBlock.toJSON() : <any>undefined;
        data["columnBlock"] = this.columnBlock ? this.columnBlock.toJSON() : <any>undefined;
        data["htmlColumnBlock"] = this.htmlColumnBlock ? this.htmlColumnBlock.toJSON() : <any>undefined;
        data["htmlBlock"] = this.htmlBlock ? this.htmlBlock.toJSON() : <any>undefined;
        data["textBlock"] = this.textBlock ? this.textBlock.toJSON() : <any>undefined;
        return data; 
    }

    clone(): QuizActivityItemDto {
        const json = this.toJSON();
        let result = new QuizActivityItemDto();
        result.init(json);
        return result;
    }
}

export interface IQuizActivityItemDto {
    multiChoiceProblem: MultiChoiceProblemDto;
    multiEntryProblem: MultiEntryProblemDto;
    multiChoiceGrid: MultiChoiceGrid;
    textInputProblem: TextInputProblemDto;
    id: string;
    quizId: string;
    pageId: string;
    parentId: string | undefined;
    pageIndex: number;
    itemNumber: number;
    itemIndex: number;
    layoutTemplate: string | undefined;
    isProblem: boolean;
    title: string | undefined;
    colSpan: number;
    scoring: ScoreRule;
    isActive: boolean;
    itemType: string | undefined;
    isGroup: boolean;
    simpleContentBlock: SimpleContentBlock;
    columnBlock: ColumnBlock;
    htmlColumnBlock: HtmlColumnBlock;
    htmlBlock: HtmlBlock;
    textBlock: TextBlock;
}

export class QuizPageDto implements IQuizPageDto {
    quizId: string;
    title: string | undefined;
    itemIndex: number;
    id: string;

    constructor(data?: IQuizPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quizId = _data["quizId"];
            this.title = _data["title"];
            this.itemIndex = _data["itemIndex"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QuizPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quizId"] = this.quizId;
        data["title"] = this.title;
        data["itemIndex"] = this.itemIndex;
        data["id"] = this.id;
        return data; 
    }

    clone(): QuizPageDto {
        const json = this.toJSON();
        let result = new QuizPageDto();
        result.init(json);
        return result;
    }
}

export interface IQuizPageDto {
    quizId: string;
    title: string | undefined;
    itemIndex: number;
    id: string;
}

export class Mark implements IMark {
    result: MarkResultKind;
    raw: number;
    weighted: number;

    constructor(data?: IMark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.raw = _data["raw"];
            this.weighted = _data["weighted"];
        }
    }

    static fromJS(data: any): Mark {
        data = typeof data === 'object' ? data : {};
        let result = new Mark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["raw"] = this.raw;
        data["weighted"] = this.weighted;
        return data; 
    }

    clone(): Mark {
        const json = this.toJSON();
        let result = new Mark();
        result.init(json);
        return result;
    }
}

export interface IMark {
    result: MarkResultKind;
    raw: number;
    weighted: number;
}

export enum MarkStatusKind {
    New = <any>"New",
    Submitted = <any>"Submitted",
    Completed = <any>"Completed",
    Error = <any>"Error",
}

export class ResponseEntry implements IResponseEntry {
    key: string | undefined;
    values: { [key: string]: string; } | undefined;
    readonly hasValue: boolean;
    readonly isCorrect: boolean | undefined;
    mark: MarkResultKind;
    earnedPoints: number;

    constructor(data?: IResponseEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        this.values[key] = _data["values"][key];
                }
            }
            (<any>this).hasValue = _data["hasValue"];
            (<any>this).isCorrect = _data["isCorrect"];
            this.mark = _data["mark"];
            this.earnedPoints = _data["earnedPoints"];
        }
    }

    static fromJS(data: any): ResponseEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    data["values"][key] = this.values[key];
            }
        }
        data["hasValue"] = this.hasValue;
        data["isCorrect"] = this.isCorrect;
        data["mark"] = this.mark;
        data["earnedPoints"] = this.earnedPoints;
        return data; 
    }

    clone(): ResponseEntry {
        const json = this.toJSON();
        let result = new ResponseEntry();
        result.init(json);
        return result;
    }
}

export interface IResponseEntry {
    key: string | undefined;
    values: { [key: string]: string; } | undefined;
    hasValue: boolean;
    isCorrect: boolean | undefined;
    mark: MarkResultKind;
    earnedPoints: number;
}

export class ProblemResponseDto implements IProblemResponseDto {
    id: string;
    attemptId: string;
    itemId: string;
    isAnswered: boolean;
    mark: Mark;
    problemType: string | undefined;
    markerMode: MarkerModeKind;
    markStatus: MarkStatusKind;
    entries: { [key: string]: ResponseEntry; } | undefined;
    comments: string | undefined;

    constructor(data?: IProblemResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attemptId = _data["attemptId"];
            this.itemId = _data["itemId"];
            this.isAnswered = _data["isAnswered"];
            this.mark = _data["mark"] ? Mark.fromJS(_data["mark"]) : <any>undefined;
            this.problemType = _data["problemType"];
            this.markerMode = _data["markerMode"];
            this.markStatus = _data["markStatus"];
            if (_data["entries"]) {
                this.entries = {} as any;
                for (let key in _data["entries"]) {
                    if (_data["entries"].hasOwnProperty(key))
                        this.entries[key] = _data["entries"][key] ? ResponseEntry.fromJS(_data["entries"][key]) : new ResponseEntry();
                }
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ProblemResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attemptId"] = this.attemptId;
        data["itemId"] = this.itemId;
        data["isAnswered"] = this.isAnswered;
        data["mark"] = this.mark ? this.mark.toJSON() : <any>undefined;
        data["problemType"] = this.problemType;
        data["markerMode"] = this.markerMode;
        data["markStatus"] = this.markStatus;
        if (this.entries) {
            data["entries"] = {};
            for (let key in this.entries) {
                if (this.entries.hasOwnProperty(key))
                    data["entries"][key] = this.entries[key] ? this.entries[key].toJSON() : <any>undefined;
            }
        }
        data["comments"] = this.comments;
        return data; 
    }

    clone(): ProblemResponseDto {
        const json = this.toJSON();
        let result = new ProblemResponseDto();
        result.init(json);
        return result;
    }
}

export interface IProblemResponseDto {
    id: string;
    attemptId: string;
    itemId: string;
    isAnswered: boolean;
    mark: Mark;
    problemType: string | undefined;
    markerMode: MarkerModeKind;
    markStatus: MarkStatusKind;
    entries: { [key: string]: ResponseEntry; } | undefined;
    comments: string | undefined;
}

export class GetQuizAssignmentResponse implements IGetQuizAssignmentResponse {
    studentId: number;
    activityId: string;
    attemptId: string;
    attempt: QuizAttemptDto;
    items: QuizActivityItemDto[] | undefined;
    pages: QuizPageDto[] | undefined;
    responses: ProblemResponseDto[] | undefined;

    constructor(data?: IGetQuizAssignmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.activityId = _data["activityId"];
            this.attemptId = _data["attemptId"];
            this.attempt = _data["attempt"] ? QuizAttemptDto.fromJS(_data["attempt"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(QuizActivityItemDto.fromJS(item));
            }
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages.push(QuizPageDto.fromJS(item));
            }
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses.push(ProblemResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQuizAssignmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuizAssignmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["activityId"] = this.activityId;
        data["attemptId"] = this.attemptId;
        data["attempt"] = this.attempt ? this.attempt.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetQuizAssignmentResponse {
        const json = this.toJSON();
        let result = new GetQuizAssignmentResponse();
        result.init(json);
        return result;
    }
}

export interface IGetQuizAssignmentResponse {
    studentId: number;
    activityId: string;
    attemptId: string;
    attempt: QuizAttemptDto;
    items: QuizActivityItemDto[] | undefined;
    pages: QuizPageDto[] | undefined;
    responses: ProblemResponseDto[] | undefined;
}

export class Choice implements IChoice {
    name: string | undefined;
    readonly key: string | undefined;
    index: number;
    isCorrect: boolean;
    image: ImageField;
    text: string | undefined;

    constructor(data?: IChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            (<any>this).key = _data["key"];
            this.index = _data["index"];
            this.isCorrect = _data["isCorrect"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): Choice {
        data = typeof data === 'object' ? data : {};
        let result = new Choice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["key"] = this.key;
        data["index"] = this.index;
        data["isCorrect"] = this.isCorrect;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["text"] = this.text;
        return data; 
    }

    clone(): Choice {
        const json = this.toJSON();
        let result = new Choice();
        result.init(json);
        return result;
    }
}

export interface IChoice {
    name: string | undefined;
    key: string | undefined;
    index: number;
    isCorrect: boolean;
    image: ImageField;
    text: string | undefined;
}

export class ChoiceGroup implements IChoiceGroup {
    choiceType: ChoiceKind;
    columns: number;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;
    values: Choice[] | undefined;

    constructor(data?: IChoiceGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.choiceType = _data["choiceType"];
            this.columns = _data["columns"];
            this.layout = _data["layout"];
            this.textFormat = _data["textFormat"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(Choice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChoiceGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choiceType"] = this.choiceType;
        data["columns"] = this.columns;
        data["layout"] = this.layout;
        data["textFormat"] = this.textFormat;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ChoiceGroup {
        const json = this.toJSON();
        let result = new ChoiceGroup();
        result.init(json);
        return result;
    }
}

export interface IChoiceGroup {
    choiceType: ChoiceKind;
    columns: number;
    layout: ContentLayoutKind;
    textFormat: TextFormatKind;
    values: Choice[] | undefined;
}

export class Problem implements IProblem {
    solution: SimpleContentBlock;
    hints: Hint[] | undefined;
    type: string | undefined;

    protected _discriminator: string;

    constructor(data?: IProblem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "Problem";
    }

    init(_data?: any) {
        if (_data) {
            this.solution = _data["solution"] ? SimpleContentBlock.fromJS(_data["solution"]) : <any>undefined;
            if (Array.isArray(_data["hints"])) {
                this.hints = [] as any;
                for (let item of _data["hints"])
                    this.hints.push(Hint.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Problem {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MultiChoiceProblem") {
            let result = new MultiChoiceProblem();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextInputProblem") {
            let result = new TextInputProblem();
            result.init(data);
            return result;
        }
        let result = new Problem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["solution"] = this.solution ? this.solution.toJSON() : <any>undefined;
        if (Array.isArray(this.hints)) {
            data["hints"] = [];
            for (let item of this.hints)
                data["hints"].push(item.toJSON());
        }
        data["type"] = this.type;
        return data; 
    }

    clone(): Problem {
        const json = this.toJSON();
        let result = new Problem();
        result.init(json);
        return result;
    }
}

export interface IProblem {
    solution: SimpleContentBlock;
    hints: Hint[] | undefined;
    type: string | undefined;
}

export class MultiChoiceProblem extends Problem implements IMultiChoiceProblem {
    content: SimpleContentBlock;
    choices: ChoiceGroup;

    constructor(data?: IMultiChoiceProblem) {
        super(data);
        this._discriminator = "MultiChoiceProblem";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            this.choices = _data["choices"] ? ChoiceGroup.fromJS(_data["choices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MultiChoiceProblem {
        data = typeof data === 'object' ? data : {};
        let result = new MultiChoiceProblem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["choices"] = this.choices ? this.choices.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): MultiChoiceProblem {
        const json = this.toJSON();
        let result = new MultiChoiceProblem();
        result.init(json);
        return result;
    }
}

export interface IMultiChoiceProblem extends IProblem {
    content: SimpleContentBlock;
    choices: ChoiceGroup;
}

export class TextInputProblem extends Problem implements ITextInputProblem {
    content: SimpleContentBlock;
    lines: number;

    constructor(data?: ITextInputProblem) {
        super(data);
        this._discriminator = "TextInputProblem";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            this.lines = _data["lines"];
        }
    }

    static fromJS(data: any): TextInputProblem {
        data = typeof data === 'object' ? data : {};
        let result = new TextInputProblem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["lines"] = this.lines;
        super.toJSON(data);
        return data; 
    }

    clone(): TextInputProblem {
        const json = this.toJSON();
        let result = new TextInputProblem();
        result.init(json);
        return result;
    }
}

export interface ITextInputProblem extends IProblem {
    content: SimpleContentBlock;
    lines: number;
}

export enum EntryPositionKind {
    End = <any>"End",
    Inline = <any>"Inline",
    Start = <any>"Start",
}

export class EntryFieldEditDto implements IEntryFieldEditDto {
    textSegments: TextSegment[] | undefined;
    key: string | undefined;
    value: string | undefined;
    displayWidth: number;
    entryType: EntryFieldKind;
    layoutTemplate: string | undefined;
    text: string | undefined;
    image: ImageField;
    entryPosition: EntryPositionKind;
    textFormat: TextFormatKind;
    choices: ChoiceGroup;
    answer: string | undefined;
    answers: EntryAnswer[] | undefined;
    index: number;
    hasSegments: boolean;
    ignoreSpaces: boolean;
    ignoreCharacters: string | undefined;

    constructor(data?: IEntryFieldEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["textSegments"])) {
                this.textSegments = [] as any;
                for (let item of _data["textSegments"])
                    this.textSegments.push(TextSegment.fromJS(item));
            }
            this.key = _data["key"];
            this.value = _data["value"];
            this.displayWidth = _data["displayWidth"];
            this.entryType = _data["entryType"];
            this.layoutTemplate = _data["layoutTemplate"];
            this.text = _data["text"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.entryPosition = _data["entryPosition"];
            this.textFormat = _data["textFormat"];
            this.choices = _data["choices"] ? ChoiceGroup.fromJS(_data["choices"]) : <any>undefined;
            this.answer = _data["answer"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers.push(EntryAnswer.fromJS(item));
            }
            this.index = _data["index"];
            this.hasSegments = _data["hasSegments"];
            this.ignoreSpaces = _data["ignoreSpaces"];
            this.ignoreCharacters = _data["ignoreCharacters"];
        }
    }

    static fromJS(data: any): EntryFieldEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntryFieldEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.textSegments)) {
            data["textSegments"] = [];
            for (let item of this.textSegments)
                data["textSegments"].push(item.toJSON());
        }
        data["key"] = this.key;
        data["value"] = this.value;
        data["displayWidth"] = this.displayWidth;
        data["entryType"] = this.entryType;
        data["layoutTemplate"] = this.layoutTemplate;
        data["text"] = this.text;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["entryPosition"] = this.entryPosition;
        data["textFormat"] = this.textFormat;
        data["choices"] = this.choices ? this.choices.toJSON() : <any>undefined;
        data["answer"] = this.answer;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["index"] = this.index;
        data["hasSegments"] = this.hasSegments;
        data["ignoreSpaces"] = this.ignoreSpaces;
        data["ignoreCharacters"] = this.ignoreCharacters;
        return data; 
    }

    clone(): EntryFieldEditDto {
        const json = this.toJSON();
        let result = new EntryFieldEditDto();
        result.init(json);
        return result;
    }
}

export interface IEntryFieldEditDto {
    textSegments: TextSegment[] | undefined;
    key: string | undefined;
    value: string | undefined;
    displayWidth: number;
    entryType: EntryFieldKind;
    layoutTemplate: string | undefined;
    text: string | undefined;
    image: ImageField;
    entryPosition: EntryPositionKind;
    textFormat: TextFormatKind;
    choices: ChoiceGroup;
    answer: string | undefined;
    answers: EntryAnswer[] | undefined;
    index: number;
    hasSegments: boolean;
    ignoreSpaces: boolean;
    ignoreCharacters: string | undefined;
}

export class ProblemEditDto implements IProblemEditDto {
    solution: SimpleContentBlock;
    hints: Hint[] | undefined;
    type: string | undefined;

    protected _discriminator: string;

    constructor(data?: IProblemEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ProblemEditDto";
    }

    init(_data?: any) {
        if (_data) {
            this.solution = _data["solution"] ? SimpleContentBlock.fromJS(_data["solution"]) : <any>undefined;
            if (Array.isArray(_data["hints"])) {
                this.hints = [] as any;
                for (let item of _data["hints"])
                    this.hints.push(Hint.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ProblemEditDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MultiEntryEditDto") {
            let result = new MultiEntryEditDto();
            result.init(data);
            return result;
        }
        let result = new ProblemEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["solution"] = this.solution ? this.solution.toJSON() : <any>undefined;
        if (Array.isArray(this.hints)) {
            data["hints"] = [];
            for (let item of this.hints)
                data["hints"].push(item.toJSON());
        }
        data["type"] = this.type;
        return data; 
    }

    clone(): ProblemEditDto {
        const json = this.toJSON();
        let result = new ProblemEditDto();
        result.init(json);
        return result;
    }
}

export interface IProblemEditDto {
    solution: SimpleContentBlock;
    hints: Hint[] | undefined;
    type: string | undefined;
}

export class MultiEntryEditDto extends ProblemEditDto implements IMultiEntryEditDto {
    textSegments: TextSegment[] | undefined;
    entryType: MultiEntryType;
    content: SimpleContentBlock;
    fields: EntryFieldEditDto[] | undefined;
    hasSegments: boolean;

    constructor(data?: IMultiEntryEditDto) {
        super(data);
        this._discriminator = "MultiEntryEditDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["textSegments"])) {
                this.textSegments = [] as any;
                for (let item of _data["textSegments"])
                    this.textSegments.push(TextSegment.fromJS(item));
            }
            this.entryType = _data["entryType"];
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields.push(EntryFieldEditDto.fromJS(item));
            }
            this.hasSegments = _data["hasSegments"];
        }
    }

    static fromJS(data: any): MultiEntryEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiEntryEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.textSegments)) {
            data["textSegments"] = [];
            for (let item of this.textSegments)
                data["textSegments"].push(item.toJSON());
        }
        data["entryType"] = this.entryType;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["hasSegments"] = this.hasSegments;
        super.toJSON(data);
        return data; 
    }

    clone(): MultiEntryEditDto {
        const json = this.toJSON();
        let result = new MultiEntryEditDto();
        result.init(json);
        return result;
    }
}

export interface IMultiEntryEditDto extends IProblemEditDto {
    textSegments: TextSegment[] | undefined;
    entryType: MultiEntryType;
    content: SimpleContentBlock;
    fields: EntryFieldEditDto[] | undefined;
    hasSegments: boolean;
}

export class EntryColumn implements IEntryColumn {
    label: string | undefined;
    image: ImageField;
    fieldName: string | undefined;
    index: number;

    constructor(data?: IEntryColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.image = _data["image"] ? ImageField.fromJS(_data["image"]) : <any>undefined;
            this.fieldName = _data["fieldName"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): EntryColumn {
        data = typeof data === 'object' ? data : {};
        let result = new EntryColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["fieldName"] = this.fieldName;
        data["index"] = this.index;
        return data; 
    }

    clone(): EntryColumn {
        const json = this.toJSON();
        let result = new EntryColumn();
        result.init(json);
        return result;
    }
}

export interface IEntryColumn {
    label: string | undefined;
    image: ImageField;
    fieldName: string | undefined;
    index: number;
}

export class MultiEntryGrid implements IMultiEntryGrid {
    content: SimpleContentBlock;
    labelColumn: EntryColumn;
    entryColumns: EntryColumn[] | undefined;
    colSpan: number;
    type: string | undefined;

    constructor(data?: IMultiEntryGrid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] ? SimpleContentBlock.fromJS(_data["content"]) : <any>undefined;
            this.labelColumn = _data["labelColumn"] ? EntryColumn.fromJS(_data["labelColumn"]) : <any>undefined;
            if (Array.isArray(_data["entryColumns"])) {
                this.entryColumns = [] as any;
                for (let item of _data["entryColumns"])
                    this.entryColumns.push(EntryColumn.fromJS(item));
            }
            this.colSpan = _data["colSpan"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): MultiEntryGrid {
        data = typeof data === 'object' ? data : {};
        let result = new MultiEntryGrid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["labelColumn"] = this.labelColumn ? this.labelColumn.toJSON() : <any>undefined;
        if (Array.isArray(this.entryColumns)) {
            data["entryColumns"] = [];
            for (let item of this.entryColumns)
                data["entryColumns"].push(item.toJSON());
        }
        data["colSpan"] = this.colSpan;
        data["type"] = this.type;
        return data; 
    }

    clone(): MultiEntryGrid {
        const json = this.toJSON();
        let result = new MultiEntryGrid();
        result.init(json);
        return result;
    }
}

export interface IMultiEntryGrid {
    content: SimpleContentBlock;
    labelColumn: EntryColumn;
    entryColumns: EntryColumn[] | undefined;
    colSpan: number;
    type: string | undefined;
}

export class EntryProblemGroup implements IEntryProblemGroup {
    fieldType: EntryFieldKind;
    entryType: MultiEntryType;
    choices: Choice[] | undefined;
    colSpan: number;
    type: string | undefined;

    constructor(data?: IEntryProblemGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldType = _data["fieldType"];
            this.entryType = _data["entryType"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices.push(Choice.fromJS(item));
            }
            this.colSpan = _data["colSpan"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EntryProblemGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EntryProblemGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldType"] = this.fieldType;
        data["entryType"] = this.entryType;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        data["colSpan"] = this.colSpan;
        data["type"] = this.type;
        return data; 
    }

    clone(): EntryProblemGroup {
        const json = this.toJSON();
        let result = new EntryProblemGroup();
        result.init(json);
        return result;
    }
}

export interface IEntryProblemGroup {
    fieldType: EntryFieldKind;
    entryType: MultiEntryType;
    choices: Choice[] | undefined;
    colSpan: number;
    type: string | undefined;
}

export class QuizItemEditDto implements IQuizItemEditDto {
    multiChoiceProblem: MultiChoiceProblem;
    textInputProblem: TextInputProblem;
    multiEntryProblem: MultiEntryEditDto;
    multiChoiceGrid: MultiChoiceGrid;
    multiEntryGrid: MultiEntryGrid;
    entryProblemGroup: EntryProblemGroup;
    id: string;
    quizId: string;
    pageId: string;
    parentId: string | undefined;
    pageIndex: number;
    itemNumber: number;
    itemIndex: number;
    isProblem: boolean;
    title: string | undefined;
    isNumbered: boolean;
    colSpan: number;
    scoring: ScoreRule;
    topicId: number;
    isActive: boolean;
    itemType: string | undefined;
    isGroup: boolean;
    simpleContentBlock: SimpleContentBlock;
    columnBlock: ColumnBlock;
    htmlColumnBlock: HtmlColumnBlock;
    htmlBlock: HtmlBlock;
    textBlock: TextBlock;

    constructor(data?: IQuizItemEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiChoiceProblem = _data["multiChoiceProblem"] ? MultiChoiceProblem.fromJS(_data["multiChoiceProblem"]) : <any>undefined;
            this.textInputProblem = _data["textInputProblem"] ? TextInputProblem.fromJS(_data["textInputProblem"]) : <any>undefined;
            this.multiEntryProblem = _data["multiEntryProblem"] ? MultiEntryEditDto.fromJS(_data["multiEntryProblem"]) : <any>undefined;
            this.multiChoiceGrid = _data["multiChoiceGrid"] ? MultiChoiceGrid.fromJS(_data["multiChoiceGrid"]) : <any>undefined;
            this.multiEntryGrid = _data["multiEntryGrid"] ? MultiEntryGrid.fromJS(_data["multiEntryGrid"]) : <any>undefined;
            this.entryProblemGroup = _data["entryProblemGroup"] ? EntryProblemGroup.fromJS(_data["entryProblemGroup"]) : <any>undefined;
            this.id = _data["id"];
            this.quizId = _data["quizId"];
            this.pageId = _data["pageId"];
            this.parentId = _data["parentId"];
            this.pageIndex = _data["pageIndex"];
            this.itemNumber = _data["itemNumber"];
            this.itemIndex = _data["itemIndex"];
            this.isProblem = _data["isProblem"];
            this.title = _data["title"];
            this.isNumbered = _data["isNumbered"];
            this.colSpan = _data["colSpan"];
            this.scoring = _data["scoring"] ? ScoreRule.fromJS(_data["scoring"]) : <any>undefined;
            this.topicId = _data["topicId"];
            this.isActive = _data["isActive"];
            this.itemType = _data["itemType"];
            this.isGroup = _data["isGroup"];
            this.simpleContentBlock = _data["simpleContentBlock"] ? SimpleContentBlock.fromJS(_data["simpleContentBlock"]) : <any>undefined;
            this.columnBlock = _data["columnBlock"] ? ColumnBlock.fromJS(_data["columnBlock"]) : <any>undefined;
            this.htmlColumnBlock = _data["htmlColumnBlock"] ? HtmlColumnBlock.fromJS(_data["htmlColumnBlock"]) : <any>undefined;
            this.htmlBlock = _data["htmlBlock"] ? HtmlBlock.fromJS(_data["htmlBlock"]) : <any>undefined;
            this.textBlock = _data["textBlock"] ? TextBlock.fromJS(_data["textBlock"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuizItemEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizItemEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiChoiceProblem"] = this.multiChoiceProblem ? this.multiChoiceProblem.toJSON() : <any>undefined;
        data["textInputProblem"] = this.textInputProblem ? this.textInputProblem.toJSON() : <any>undefined;
        data["multiEntryProblem"] = this.multiEntryProblem ? this.multiEntryProblem.toJSON() : <any>undefined;
        data["multiChoiceGrid"] = this.multiChoiceGrid ? this.multiChoiceGrid.toJSON() : <any>undefined;
        data["multiEntryGrid"] = this.multiEntryGrid ? this.multiEntryGrid.toJSON() : <any>undefined;
        data["entryProblemGroup"] = this.entryProblemGroup ? this.entryProblemGroup.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["quizId"] = this.quizId;
        data["pageId"] = this.pageId;
        data["parentId"] = this.parentId;
        data["pageIndex"] = this.pageIndex;
        data["itemNumber"] = this.itemNumber;
        data["itemIndex"] = this.itemIndex;
        data["isProblem"] = this.isProblem;
        data["title"] = this.title;
        data["isNumbered"] = this.isNumbered;
        data["colSpan"] = this.colSpan;
        data["scoring"] = this.scoring ? this.scoring.toJSON() : <any>undefined;
        data["topicId"] = this.topicId;
        data["isActive"] = this.isActive;
        data["itemType"] = this.itemType;
        data["isGroup"] = this.isGroup;
        data["simpleContentBlock"] = this.simpleContentBlock ? this.simpleContentBlock.toJSON() : <any>undefined;
        data["columnBlock"] = this.columnBlock ? this.columnBlock.toJSON() : <any>undefined;
        data["htmlColumnBlock"] = this.htmlColumnBlock ? this.htmlColumnBlock.toJSON() : <any>undefined;
        data["htmlBlock"] = this.htmlBlock ? this.htmlBlock.toJSON() : <any>undefined;
        data["textBlock"] = this.textBlock ? this.textBlock.toJSON() : <any>undefined;
        return data; 
    }

    clone(): QuizItemEditDto {
        const json = this.toJSON();
        let result = new QuizItemEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuizItemEditDto {
    multiChoiceProblem: MultiChoiceProblem;
    textInputProblem: TextInputProblem;
    multiEntryProblem: MultiEntryEditDto;
    multiChoiceGrid: MultiChoiceGrid;
    multiEntryGrid: MultiEntryGrid;
    entryProblemGroup: EntryProblemGroup;
    id: string;
    quizId: string;
    pageId: string;
    parentId: string | undefined;
    pageIndex: number;
    itemNumber: number;
    itemIndex: number;
    isProblem: boolean;
    title: string | undefined;
    isNumbered: boolean;
    colSpan: number;
    scoring: ScoreRule;
    topicId: number;
    isActive: boolean;
    itemType: string | undefined;
    isGroup: boolean;
    simpleContentBlock: SimpleContentBlock;
    columnBlock: ColumnBlock;
    htmlColumnBlock: HtmlColumnBlock;
    htmlBlock: HtmlBlock;
    textBlock: TextBlock;
}

export class UpdateQuizItemInput implements IUpdateQuizItemInput {
    item: QuizItemEditDto;
    readonly id: string;

    constructor(data?: IUpdateQuizItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? QuizItemEditDto.fromJS(_data["item"]) : <any>undefined;
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateQuizItemInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuizItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateQuizItemInput {
        const json = this.toJSON();
        let result = new UpdateQuizItemInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateQuizItemInput {
    item: QuizItemEditDto;
    id: string;
}

export class QuizItemPosition implements IQuizItemPosition {
    id: string;
    quizId: string;
    pageId: string;
    parentId: string | undefined;
    pagePosition: number;
    pageItemPosition: number;
    groupItemPosition: number;
    itemIndex: number;
    isNumbered: boolean;
    itemNumber: number;
    itemPosition: number;

    constructor(data?: IQuizItemPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quizId = _data["quizId"];
            this.pageId = _data["pageId"];
            this.parentId = _data["parentId"];
            this.pagePosition = _data["pagePosition"];
            this.pageItemPosition = _data["pageItemPosition"];
            this.groupItemPosition = _data["groupItemPosition"];
            this.itemIndex = _data["itemIndex"];
            this.isNumbered = _data["isNumbered"];
            this.itemNumber = _data["itemNumber"];
            this.itemPosition = _data["itemPosition"];
        }
    }

    static fromJS(data: any): QuizItemPosition {
        data = typeof data === 'object' ? data : {};
        let result = new QuizItemPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quizId"] = this.quizId;
        data["pageId"] = this.pageId;
        data["parentId"] = this.parentId;
        data["pagePosition"] = this.pagePosition;
        data["pageItemPosition"] = this.pageItemPosition;
        data["groupItemPosition"] = this.groupItemPosition;
        data["itemIndex"] = this.itemIndex;
        data["isNumbered"] = this.isNumbered;
        data["itemNumber"] = this.itemNumber;
        data["itemPosition"] = this.itemPosition;
        return data; 
    }

    clone(): QuizItemPosition {
        const json = this.toJSON();
        let result = new QuizItemPosition();
        result.init(json);
        return result;
    }
}

export interface IQuizItemPosition {
    id: string;
    quizId: string;
    pageId: string;
    parentId: string | undefined;
    pagePosition: number;
    pageItemPosition: number;
    groupItemPosition: number;
    itemIndex: number;
    isNumbered: boolean;
    itemNumber: number;
    itemPosition: number;
}

export class QuizEditDto implements IQuizEditDto {
    id: string;
    items: QuizItemEditDto[] | undefined;
    page: QuizEditPageDto;
    numbers: QuizItemPosition[] | undefined;

    constructor(data?: IQuizEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(QuizItemEditDto.fromJS(item));
            }
            this.page = _data["page"] ? QuizEditPageDto.fromJS(_data["page"]) : <any>undefined;
            if (Array.isArray(_data["numbers"])) {
                this.numbers = [] as any;
                for (let item of _data["numbers"])
                    this.numbers.push(QuizItemPosition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuizEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuizEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        if (Array.isArray(this.numbers)) {
            data["numbers"] = [];
            for (let item of this.numbers)
                data["numbers"].push(item.toJSON());
        }
        return data; 
    }

    clone(): QuizEditDto {
        const json = this.toJSON();
        let result = new QuizEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuizEditDto {
    id: string;
    items: QuizItemEditDto[] | undefined;
    page: QuizEditPageDto;
    numbers: QuizItemPosition[] | undefined;
}

export class BlockType implements IBlockType {
    displayName: string | undefined;
    category: string | undefined;
    icon: string | undefined;
    isUnlisted: boolean;
    isGeneric: boolean;
    component: string | undefined;
    useCustomView: boolean;
    type: string | undefined;
    name: string | undefined;

    constructor(data?: IBlockType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.category = _data["category"];
            this.icon = _data["icon"];
            this.isUnlisted = _data["isUnlisted"];
            this.isGeneric = _data["isGeneric"];
            this.component = _data["component"];
            this.useCustomView = _data["useCustomView"];
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BlockType {
        data = typeof data === 'object' ? data : {};
        let result = new BlockType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["category"] = this.category;
        data["icon"] = this.icon;
        data["isUnlisted"] = this.isUnlisted;
        data["isGeneric"] = this.isGeneric;
        data["component"] = this.component;
        data["useCustomView"] = this.useCustomView;
        data["type"] = this.type;
        data["name"] = this.name;
        return data; 
    }

    clone(): BlockType {
        const json = this.toJSON();
        let result = new BlockType();
        result.init(json);
        return result;
    }
}

export interface IBlockType {
    displayName: string | undefined;
    category: string | undefined;
    icon: string | undefined;
    isUnlisted: boolean;
    isGeneric: boolean;
    component: string | undefined;
    useCustomView: boolean;
    type: string | undefined;
    name: string | undefined;
}

export class CreateQuizItemInput implements ICreateQuizItemInput {
    blockType: string | undefined;
    quizId: string;
    pageId: string;
    itemIndex: number;
    itemNumber: number;
    parentId: string | undefined;
    readonly id: string;

    constructor(data?: ICreateQuizItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blockType = _data["blockType"];
            this.quizId = _data["quizId"];
            this.pageId = _data["pageId"];
            this.itemIndex = _data["itemIndex"];
            this.itemNumber = _data["itemNumber"];
            this.parentId = _data["parentId"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): CreateQuizItemInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuizItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blockType"] = this.blockType;
        data["quizId"] = this.quizId;
        data["pageId"] = this.pageId;
        data["itemIndex"] = this.itemIndex;
        data["itemNumber"] = this.itemNumber;
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateQuizItemInput {
        const json = this.toJSON();
        let result = new CreateQuizItemInput();
        result.init(json);
        return result;
    }
}

export interface ICreateQuizItemInput {
    blockType: string | undefined;
    quizId: string;
    pageId: string;
    itemIndex: number;
    itemNumber: number;
    parentId: string | undefined;
    id: string;
}

export class NumberItemsInput implements INumberItemsInput {
    activityId: string;
    changedNumbers: QuizItemPosition[] | undefined;
    readonly id: string;

    constructor(data?: INumberItemsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            if (Array.isArray(_data["changedNumbers"])) {
                this.changedNumbers = [] as any;
                for (let item of _data["changedNumbers"])
                    this.changedNumbers.push(QuizItemPosition.fromJS(item));
            }
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): NumberItemsInput {
        data = typeof data === 'object' ? data : {};
        let result = new NumberItemsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        if (Array.isArray(this.changedNumbers)) {
            data["changedNumbers"] = [];
            for (let item of this.changedNumbers)
                data["changedNumbers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): NumberItemsInput {
        const json = this.toJSON();
        let result = new NumberItemsInput();
        result.init(json);
        return result;
    }
}

export interface INumberItemsInput {
    activityId: string;
    changedNumbers: QuizItemPosition[] | undefined;
    id: string;
}

export class AddPageRequest implements IAddPageRequest {
    quizId: string;
    pageIndex: number;

    constructor(data?: IAddPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quizId = _data["quizId"];
            this.pageIndex = _data["pageIndex"];
        }
    }

    static fromJS(data: any): AddPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quizId"] = this.quizId;
        data["pageIndex"] = this.pageIndex;
        return data; 
    }

    clone(): AddPageRequest {
        const json = this.toJSON();
        let result = new AddPageRequest();
        result.init(json);
        return result;
    }
}

export interface IAddPageRequest {
    quizId: string;
    pageIndex: number;
}

export class RecordingActivityDto implements IRecordingActivityDto {
    courseId: number;
    activityId: string;
    url: string | undefined;
    videoType: string | undefined;
    videoId: string | undefined;
    videoUrl: string | undefined;

    constructor(data?: IRecordingActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.activityId = _data["activityId"];
            this.url = _data["url"];
            this.videoType = _data["videoType"];
            this.videoId = _data["videoId"];
            this.videoUrl = _data["videoUrl"];
        }
    }

    static fromJS(data: any): RecordingActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordingActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["activityId"] = this.activityId;
        data["url"] = this.url;
        data["videoType"] = this.videoType;
        data["videoId"] = this.videoId;
        data["videoUrl"] = this.videoUrl;
        return data; 
    }

    clone(): RecordingActivityDto {
        const json = this.toJSON();
        let result = new RecordingActivityDto();
        result.init(json);
        return result;
    }
}

export interface IRecordingActivityDto {
    courseId: number;
    activityId: string;
    url: string | undefined;
    videoType: string | undefined;
    videoId: string | undefined;
    videoUrl: string | undefined;
}

export class GetStudentActivityInput implements IGetStudentActivityInput {
    courseId: number;
    studentId: number;

    constructor(data?: IGetStudentActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.studentId = _data["studentId"];
        }
    }

    static fromJS(data: any): GetStudentActivityInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["studentId"] = this.studentId;
        return data; 
    }

    clone(): GetStudentActivityInput {
        const json = this.toJSON();
        let result = new GetStudentActivityInput();
        result.init(json);
        return result;
    }
}

export interface IGetStudentActivityInput {
    courseId: number;
    studentId: number;
}

export class StudentActivityInfo implements IStudentActivityInfo {
    studentId: number;
    activityId: string;
    subjectId: number;
    subject: string | undefined;
    title: string | undefined;
    assignmentTypeId: number;
    assignmentType: string | undefined;
    activityType: string | undefined;
    activityStatus: ActivityStatusKind;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    completedTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    score: number;
    lastAttemptId: string | undefined;
    readonly isCompleted: boolean;
    id: string;

    constructor(data?: IStudentActivityInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.activityId = _data["activityId"];
            this.subjectId = _data["subjectId"];
            this.subject = _data["subject"];
            this.title = _data["title"];
            this.assignmentTypeId = _data["assignmentTypeId"];
            this.assignmentType = _data["assignmentType"];
            this.activityType = _data["activityType"];
            this.activityStatus = _data["activityStatus"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.completedTime = _data["completedTime"] ? moment(_data["completedTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.score = _data["score"];
            this.lastAttemptId = _data["lastAttemptId"];
            (<any>this).isCompleted = _data["isCompleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StudentActivityInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StudentActivityInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["activityId"] = this.activityId;
        data["subjectId"] = this.subjectId;
        data["subject"] = this.subject;
        data["title"] = this.title;
        data["assignmentTypeId"] = this.assignmentTypeId;
        data["assignmentType"] = this.assignmentType;
        data["activityType"] = this.activityType;
        data["activityStatus"] = this.activityStatus;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["completedTime"] = this.completedTime ? this.completedTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["score"] = this.score;
        data["lastAttemptId"] = this.lastAttemptId;
        data["isCompleted"] = this.isCompleted;
        data["id"] = this.id;
        return data; 
    }

    clone(): StudentActivityInfo {
        const json = this.toJSON();
        let result = new StudentActivityInfo();
        result.init(json);
        return result;
    }
}

export interface IStudentActivityInfo {
    studentId: number;
    activityId: string;
    subjectId: number;
    subject: string | undefined;
    title: string | undefined;
    assignmentTypeId: number;
    assignmentType: string | undefined;
    activityType: string | undefined;
    activityStatus: ActivityStatusKind;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    completedTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    score: number;
    lastAttemptId: string | undefined;
    isCompleted: boolean;
    id: string;
}

export class ResetStudentActivityInput implements IResetStudentActivityInput {
    studentId: number;
    activityId: string;
    readonly id: string;

    constructor(data?: IResetStudentActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.activityId = _data["activityId"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): ResetStudentActivityInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetStudentActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["activityId"] = this.activityId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ResetStudentActivityInput {
        const json = this.toJSON();
        let result = new ResetStudentActivityInput();
        result.init(json);
        return result;
    }
}

export interface IResetStudentActivityInput {
    studentId: number;
    activityId: string;
    id: string;
}

export class RestartStudentQuizInput implements IRestartStudentQuizInput {
    studentId: number;
    activityId: string;
    readonly id: string;

    constructor(data?: IRestartStudentQuizInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.activityId = _data["activityId"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): RestartStudentQuizInput {
        data = typeof data === 'object' ? data : {};
        let result = new RestartStudentQuizInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["activityId"] = this.activityId;
        data["id"] = this.id;
        return data; 
    }

    clone(): RestartStudentQuizInput {
        const json = this.toJSON();
        let result = new RestartStudentQuizInput();
        result.init(json);
        return result;
    }
}

export interface IRestartStudentQuizInput {
    studentId: number;
    activityId: string;
    id: string;
}

export enum SubscriptionStatusKind {
    Active = <any>"Active",
    Trial = <any>"Trial",
    TrialExpired = <any>"TrialExpired",
    Expired = <any>"Expired",
    Cancelled = <any>"Cancelled",
    InActive = <any>"InActive",
    Completed = <any>"Completed",
    Preview = <any>"Preview",
}

export class GetStudentsInput implements IGetStudentsInput {
    courseId: number;
    searchText: string | undefined;
    subscriptionStatus: SubscriptionStatusKind;

    constructor(data?: IGetStudentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.searchText = _data["searchText"];
            this.subscriptionStatus = _data["subscriptionStatus"];
        }
    }

    static fromJS(data: any): GetStudentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["searchText"] = this.searchText;
        data["subscriptionStatus"] = this.subscriptionStatus;
        return data; 
    }

    clone(): GetStudentsInput {
        const json = this.toJSON();
        let result = new GetStudentsInput();
        result.init(json);
        return result;
    }
}

export interface IGetStudentsInput {
    courseId: number;
    searchText: string | undefined;
    subscriptionStatus: SubscriptionStatusKind;
}

export class StudentInfo implements IStudentInfo {
    studentId: number;
    courseId: number;
    course: string | undefined;
    grade: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    parentName: string | undefined;
    contactNumber: string | undefined;
    subscriptionId: string;
    accessLevel: string | undefined;
    accessMode: string | undefined;
    subscriptionStatus: string | undefined;
    startDate: moment.Moment | undefined;
    firstLoginTime: moment.Moment | undefined;
    firstCompletedTime: moment.Moment | undefined;
    completedAssignments: number;
    totalAssignments: number;
    averageScore: number;

    constructor(data?: IStudentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.courseId = _data["courseId"];
            this.course = _data["course"];
            this.grade = _data["grade"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.parentName = _data["parentName"];
            this.contactNumber = _data["contactNumber"];
            this.subscriptionId = _data["subscriptionId"];
            this.accessLevel = _data["accessLevel"];
            this.accessMode = _data["accessMode"];
            this.subscriptionStatus = _data["subscriptionStatus"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.firstLoginTime = _data["firstLoginTime"] ? moment(_data["firstLoginTime"].toString()) : <any>undefined;
            this.firstCompletedTime = _data["firstCompletedTime"] ? moment(_data["firstCompletedTime"].toString()) : <any>undefined;
            this.completedAssignments = _data["completedAssignments"];
            this.totalAssignments = _data["totalAssignments"];
            this.averageScore = _data["averageScore"];
        }
    }

    static fromJS(data: any): StudentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StudentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["courseId"] = this.courseId;
        data["course"] = this.course;
        data["grade"] = this.grade;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["parentName"] = this.parentName;
        data["contactNumber"] = this.contactNumber;
        data["subscriptionId"] = this.subscriptionId;
        data["accessLevel"] = this.accessLevel;
        data["accessMode"] = this.accessMode;
        data["subscriptionStatus"] = this.subscriptionStatus;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["firstLoginTime"] = this.firstLoginTime ? this.firstLoginTime.toISOString() : <any>undefined;
        data["firstCompletedTime"] = this.firstCompletedTime ? this.firstCompletedTime.toISOString() : <any>undefined;
        data["completedAssignments"] = this.completedAssignments;
        data["totalAssignments"] = this.totalAssignments;
        data["averageScore"] = this.averageScore;
        return data; 
    }

    clone(): StudentInfo {
        const json = this.toJSON();
        let result = new StudentInfo();
        result.init(json);
        return result;
    }
}

export interface IStudentInfo {
    studentId: number;
    courseId: number;
    course: string | undefined;
    grade: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    parentName: string | undefined;
    contactNumber: string | undefined;
    subscriptionId: string;
    accessLevel: string | undefined;
    accessMode: string | undefined;
    subscriptionStatus: string | undefined;
    startDate: moment.Moment | undefined;
    firstLoginTime: moment.Moment | undefined;
    firstCompletedTime: moment.Moment | undefined;
    completedAssignments: number;
    totalAssignments: number;
    averageScore: number;
}

export class PagedResultDtoOfSubjectDto implements IPagedResultDtoOfSubjectDto {
    totalCount: number;
    items: SubjectDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SubjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfSubjectDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfSubjectDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfSubjectDto {
    totalCount: number;
    items: SubjectDto[] | undefined;
}

export class LearningObjectiveModel implements ILearningObjectiveModel {
    topicId: number;
    title: string | undefined;
    summary: string | undefined;
    indexNumber: number;
    id: string;

    constructor(data?: ILearningObjectiveModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.title = _data["title"];
            this.summary = _data["summary"];
            this.indexNumber = _data["indexNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LearningObjectiveModel {
        data = typeof data === 'object' ? data : {};
        let result = new LearningObjectiveModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["title"] = this.title;
        data["summary"] = this.summary;
        data["indexNumber"] = this.indexNumber;
        data["id"] = this.id;
        return data; 
    }

    clone(): LearningObjectiveModel {
        const json = this.toJSON();
        let result = new LearningObjectiveModel();
        result.init(json);
        return result;
    }
}

export interface ILearningObjectiveModel {
    topicId: number;
    title: string | undefined;
    summary: string | undefined;
    indexNumber: number;
    id: string;
}

export class TopicModel implements ITopicModel {
    title: string | undefined;
    description: string | undefined;
    courseId: number;
    subjectId: number;
    indexNumber: number;
    previewImage: ImageField;
    objectives: LearningObjectiveModel[] | undefined;
    id: number;

    constructor(data?: ITopicModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.courseId = _data["courseId"];
            this.subjectId = _data["subjectId"];
            this.indexNumber = _data["indexNumber"];
            this.previewImage = _data["previewImage"] ? ImageField.fromJS(_data["previewImage"]) : <any>undefined;
            if (Array.isArray(_data["objectives"])) {
                this.objectives = [] as any;
                for (let item of _data["objectives"])
                    this.objectives.push(LearningObjectiveModel.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TopicModel {
        data = typeof data === 'object' ? data : {};
        let result = new TopicModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["courseId"] = this.courseId;
        data["subjectId"] = this.subjectId;
        data["indexNumber"] = this.indexNumber;
        data["previewImage"] = this.previewImage ? this.previewImage.toJSON() : <any>undefined;
        if (Array.isArray(this.objectives)) {
            data["objectives"] = [];
            for (let item of this.objectives)
                data["objectives"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): TopicModel {
        const json = this.toJSON();
        let result = new TopicModel();
        result.init(json);
        return result;
    }
}

export interface ITopicModel {
    title: string | undefined;
    description: string | undefined;
    courseId: number;
    subjectId: number;
    indexNumber: number;
    previewImage: ImageField;
    objectives: LearningObjectiveModel[] | undefined;
    id: number;
}

export class ItemIndex implements IItemIndex {
    itemId: number;
    indexNumber: number;

    constructor(data?: IItemIndex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.indexNumber = _data["indexNumber"];
        }
    }

    static fromJS(data: any): ItemIndex {
        data = typeof data === 'object' ? data : {};
        let result = new ItemIndex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["indexNumber"] = this.indexNumber;
        return data; 
    }

    clone(): ItemIndex {
        const json = this.toJSON();
        let result = new ItemIndex();
        result.init(json);
        return result;
    }
}

export interface IItemIndex {
    itemId: number;
    indexNumber: number;
}

export class ReorderItemsInput implements IReorderItemsInput {
    items: ItemIndex[] | undefined;

    constructor(data?: IReorderItemsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ItemIndex.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReorderItemsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderItemsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ReorderItemsInput {
        const json = this.toJSON();
        let result = new ReorderItemsInput();
        result.init(json);
        return result;
    }
}

export interface IReorderItemsInput {
    items: ItemIndex[] | undefined;
}

export class PagedResultDtoOfTopicModel implements IPagedResultDtoOfTopicModel {
    totalCount: number;
    items: TopicModel[] | undefined;

    constructor(data?: IPagedResultDtoOfTopicModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TopicModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTopicModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTopicModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfTopicModel {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTopicModel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTopicModel {
    totalCount: number;
    items: TopicModel[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}